
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kYjgt", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $96f168e338d9fe03$export$defe85febe8b728c; });

var $fnHPc = parcelRequire("fnHPc");
const $96f168e338d9fe03$export$defe85febe8b728c = (0, $fnHPc.defineMessages)({
    getToDoneFaster: {
        id: "PaidLanding.JiraAI.getToDoneFaster",
        defaultMessage: "Get to <highlight>done</highlight> faster with Jira + Rovo AI",
        description: "Page header"
    },
    aiPoweredProjectManagement: {
        id: "PaidLanding.JiraAI.aiPoweredProjectManagement",
        defaultMessage: "AI-powered project management that removes the work around work.",
        description: "Description below the page header"
    },
    softwareDevelopment: {
        id: "PaidLanding.JiraAI.madLibPrompt.softwareDevelopment",
        defaultMessage: "Software development",
        description: "Mad-lib suggestion option 1"
    },
    productManagement: {
        id: "PaidLanding.JiraAI.madLibPrompt.productManagement",
        defaultMessage: "Product management",
        description: "Mad-lib suggestion option 2"
    },
    marketing: {
        id: "PaidLanding.JiraAI.madLibPrompt.marketing",
        defaultMessage: "Marketing",
        description: "Mad-lib suggestion option 3"
    },
    projectManagement: {
        id: "PaidLanding.JiraAI.madLibPrompt.projectManagement",
        defaultMessage: "Project management",
        description: "Mad-lib suggestion option 4"
    },
    design: {
        id: "PaidLanding.JiraAI.madLibPrompt.design",
        defaultMessage: "Design",
        description: "Mad-lib suggestion option 5"
    },
    it: {
        id: "PaidLanding.JiraAI.madLibPrompt.it",
        defaultMessage: "IT",
        description: "Mad-lib suggestion option 6"
    },
    madLib: {
        id: "PaidLanding.JiraAI.madLibPrompt.madLib",
        defaultMessage: "<workingOn>I'm working on</workingOn> {workingOnInput} <goal>with the goal of</goal> {goalInput}",
        description: "Ex: I'm working on brand awareness campaign with the goal of driving 25% more signups across email, paid, and social channels"
    },
    poweredByAi: {
        id: "PaidLanding.JiraAI.madLibPrompt.poweredByAi",
        defaultMessage: "Uses AI. Verify results.",
        description: "Description in mad-lib prompt footer"
    },
    shuffle: {
        id: "PaidLanding.JiraAI.madLibPrompt.shuffle",
        defaultMessage: "Shuffle",
        description: "Button text to shuffle mad-lib"
    },
    getStarted: {
        id: "PaidLanding.JiraAI.madLibPrompt.getStarted",
        defaultMessage: "Get started",
        description: "Button text to submit mad-lib"
    },
    rerunPrompt: {
        id: "PaidLanding.JiraAI.madLibPrompt.rerunPrompt",
        defaultMessage: "Rerun prompt",
        description: "Button text to submit mad-lib"
    },
    working: {
        id: "PaidLanding.JiraAI.madLibPrompt.working",
        defaultMessage: "Working...",
        description: "Button text for loading message"
    },
    close: {
        id: "PaidLanding.JiraAI.previewModal.close",
        defaultMessage: "Close",
        description: "Label for the close button"
    },
    paidJiraAiPreviewModal: {
        id: "PaidLanding.JiraAI.signup.previewBackground.paidJiraAiPreviewModal",
        defaultMessage: "Paid Jira AI Preview Modal",
        description: "Aria label for preview modal"
    },
    acceptableUsePolicyDisclaimer: {
        id: "PaidLanding.JiraAI.acceptableUsePolicyDisclaimer",
        defaultMessage: 'By selecting "Get started," you agree to use of a feature that is subject to Atlassian\'s <acceptableUsePolicyLink>Acceptable Use Policy</acceptableUsePolicyLink>.',
        description: "Acceptable use policy disclaimer"
    }
});

});

parcelRegister("fx9D8", function(module, exports) {
$parcel$export(module.exports, "ANALYTIC_EVENT_ACTION_SUCCEEDED", function () { return $126950114f51989e$export$d9bb70073ffb9f9d; });
$parcel$export(module.exports, "ANALYTIC_EVENT_ACTION_STARTED", function () { return $126950114f51989e$export$d72c787d1e3b9b0f; });
$parcel$export(module.exports, "ANALYTIC_EVENT_ACTION_FAILED", function () { return $126950114f51989e$export$f862cc8ed27c82d9; });
$parcel$export(module.exports, "MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME", function () { return $126950114f51989e$export$d8e28a3050ddc5e2; });
$parcel$export(module.exports, "MADLIB_FLOW", function () { return $126950114f51989e$export$58796d67e188ffce; });
$parcel$export(module.exports, "teamTypesMap", function () { return $126950114f51989e$export$c63397777d41190; });
$parcel$export(module.exports, "formatCgsData", function () { return $126950114f51989e$export$892528dbb329121c; });
$parcel$export(module.exports, "fallbackCgsData", function () { return $126950114f51989e$export$c4a621bc5a852a3; });

var $7XYQW = parcelRequire("7XYQW");

var $hc4eY = parcelRequire("hc4eY");
const $126950114f51989e$export$d9bb70073ffb9f9d = "succeeded";
const $126950114f51989e$export$d72c787d1e3b9b0f = "started";
const $126950114f51989e$export$f862cc8ed27c82d9 = "failed";
const $126950114f51989e$export$d8e28a3050ddc5e2 = "madlib content generation";
const $126950114f51989e$export$58796d67e188ffce = "madlib";
const $126950114f51989e$export$c63397777d41190 = {
    [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE)]: {
        messageKey: "softwareDevelopment"
    },
    [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT)]: {
        messageKey: "productManagement"
    },
    [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING)]: {
        messageKey: "marketing"
    },
    [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT)]: {
        messageKey: "projectManagement"
    },
    [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN)]: {
        messageKey: "design"
    },
    [(0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT)]: {
        messageKey: "it"
    }
};
const $126950114f51989e$export$a36c5d060229995b = (teamType)=>$126950114f51989e$export$c63397777d41190[teamType].messageKey;
const $126950114f51989e$var$DEFAULT_END_DATE_DAYS_FROM_NOW = 30;
const $126950114f51989e$export$892528dbb329121c = (cgsData)=>{
    if (!cgsData) return undefined;
    const dueDate = Date.now() + $126950114f51989e$var$DEFAULT_END_DATE_DAYS_FROM_NOW * 86400000;
    const relativeDays = (0, $hc4eY.getElapsedDaysFromNow)(dueDate);
    const taskPriorities = [
        "medium",
        "low",
        "low",
        "low",
        "medium",
        "medium",
        "low",
        "medium",
        "medium",
        "low"
    ];
    const assignees = [
        "Jenna Tran",
        "Raul Gonzales",
        "Aoife Burke",
        "Jenna Tran",
        "Omar Salah",
        "Bradley Philips",
        "Raul Gonzales",
        "Aoife Burke",
        "Bradley Philips",
        "Athena Ai"
    ];
    const assigneeAvatars = {
        "Aoife Burke": "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHXB.webp",
        "Athena Ai": "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHXE.webp",
        "Bradley Philips": "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHXC.webp",
        "Jenna Tran": "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHXF.webp",
        "Omar Salah": "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHXG.webp",
        "Raul Gonzales": "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHXD.webp"
    };
    const epicData = cgsData.sampleIssues.epic;
    const workItemsData = cgsData.sampleIssues.childWorkItems;
    const finalData = [];
    if (epicData) {
        const epicDueDate = new Date();
        epicDueDate.setDate(epicDueDate.getDate() + relativeDays);
        const assignee = assignees.shift() || assignees[0];
        finalData.push({
            type: "epic",
            summary: epicData.epicName,
            status: "in progress",
            dueDate: epicDueDate,
            priority: "high",
            assignee: assignee,
            assigneeImgSrc: assigneeAvatars[assignee]
        });
    }
    if (workItemsData && workItemsData.length > 0) {
        const issueDueDates = (0, $hc4eY.generateSequentialDueDates)(dueDate, workItemsData.length);
        const issueDueDateRelativeDays = issueDueDates.map((issueDueDate)=>(0, $hc4eY.getElapsedDaysFromNow)(new Date(issueDueDate).getTime()));
        workItemsData.forEach((item, index)=>{
            const taskDueDate = new Date();
            var _issueDueDateRelativeDays_index;
            taskDueDate.setDate(taskDueDate.getDate() + ((_issueDueDateRelativeDays_index = issueDueDateRelativeDays[index]) !== null && _issueDueDateRelativeDays_index !== void 0 ? _issueDueDateRelativeDays_index : relativeDays));
            const assignee = assignees.shift() || assignees[0];
            finalData.push({
                type: "task",
                summary: item.summary,
                status: "to do",
                dueDate: taskDueDate,
                priority: taskPriorities.shift() || "medium",
                assignee: assignee,
                assigneeImgSrc: assigneeAvatars[assignee]
            });
        });
    }
    return finalData;
};
const $126950114f51989e$export$c4a621bc5a852a3 = {
    cacheKey: "default",
    sampleIssues: {
        childWorkItems: [
            {
                summary: "Audit existing infrastructure dependencies for migration readiness"
            },
            {
                summary: "Provision the target environment with high availability configurations"
            },
            {
                summary: "Implement automated health checks for post-migration validation"
            },
            {
                summary: "Execute data migration to the new platform environment"
            },
            {
                summary: "Perform reliability testing on the migrated platform in staging"
            }
        ],
        epic: {
            description: "What are we doing? We are executing a migration of the existing platform to a new infrastructure or environment. Why are we doing it? To achieve the goal of improving the overall reliability of our software services. What does success look like? All platform components are successfully transitioned to the new environment and operate with improved reliability. Assumption: Specific reliability targets and target environment details are TBD.",
            epicName: "Platform migration"
        },
        spaceName: "Software Development Project"
    }
};

});
parcelRegister("7XYQW", function(module, exports) {
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE", function () { return $5ccd3f34ffab67cd$export$572242e58bd07594; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT", function () { return $5ccd3f34ffab67cd$export$d7de553940261eba; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_HR", function () { return $5ccd3f34ffab67cd$export$4c29d0d04c15e55d; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_FINANCE", function () { return $5ccd3f34ffab67cd$export$3950f7f841bf94b6; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_LEGAL", function () { return $5ccd3f34ffab67cd$export$881249b988b6030f; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", function () { return $5ccd3f34ffab67cd$export$e4824f74b9879164; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", function () { return $5ccd3f34ffab67cd$export$4f3cb0844009af52; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_SALES", function () { return $5ccd3f34ffab67cd$export$1a65d50c4a641bb4; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE", function () { return $5ccd3f34ffab67cd$export$9ee64e8fbd8b03a2; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_SOFTWARE", function () { return $5ccd3f34ffab67cd$export$b8b1ac856ba1434b; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT", function () { return $5ccd3f34ffab67cd$export$4f54a09a24fd1d74; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT", function () { return $5ccd3f34ffab67cd$export$79685802e8ff1098; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_DESIGN", function () { return $5ccd3f34ffab67cd$export$e5c438b7501b5a24; });
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL", function () { return $5ccd3f34ffab67cd$export$cbc0e551d91a692d; });

var $bYphe = parcelRequire("bYphe");

var $cnzEg = parcelRequire("cnzEg");

var $jYP3P = parcelRequire("jYP3P");
var $5ccd3f34ffab67cd$var$_productQueryParamTea, $5ccd3f34ffab67cd$var$_USER_SEGMENTATION_CL;
var $5ccd3f34ffab67cd$export$390f94ade23c5f40 = 'all-roles-eligible';
var $5ccd3f34ffab67cd$export$2f3f9640393bd078 = 'unknown';
var $5ccd3f34ffab67cd$export$4c9a72dac5ce80ae = '';
// Roles defined in user segmentation
var $5ccd3f34ffab67cd$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
var $5ccd3f34ffab67cd$export$572242e58bd07594 = 'customer-service';
var $5ccd3f34ffab67cd$export$d7de553940261eba = 'it-support';
var $5ccd3f34ffab67cd$export$4c29d0d04c15e55d = 'human-resources';
var $5ccd3f34ffab67cd$export$3950f7f841bf94b6 = 'finance';
var $5ccd3f34ffab67cd$export$881249b988b6030f = 'legal';
var $5ccd3f34ffab67cd$export$e4824f74b9879164 = 'marketing';
var $5ccd3f34ffab67cd$export$4f3cb0844009af52 = 'operations';
var $5ccd3f34ffab67cd$export$1a65d50c4a641bb4 = 'sales';
var $5ccd3f34ffab67cd$export$9ee64e8fbd8b03a2 = 'data-science';
var $5ccd3f34ffab67cd$export$b8b1ac856ba1434b = 'software-development';
var $5ccd3f34ffab67cd$export$4f54a09a24fd1d74 = 'product-management';
var $5ccd3f34ffab67cd$export$79685802e8ff1098 = 'project-management';
var $5ccd3f34ffab67cd$export$e5c438b7501b5a24 = 'design';
var $5ccd3f34ffab67cd$export$cbc0e551d91a692d = 'other-personal';
var $5ccd3f34ffab67cd$export$53d2a515d824b589 = 'skip';
var $5ccd3f34ffab67cd$export$d9b98775fefed139 = ($5ccd3f34ffab67cd$var$_productQueryParamTea = {}, (0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)($5ccd3f34ffab67cd$var$_productQueryParamTea, $5ccd3f34ffab67cd$export$b8b1ac856ba1434b, 'DEV'), $5ccd3f34ffab67cd$export$d7de553940261eba, 'ITS'), $5ccd3f34ffab67cd$export$e5c438b7501b5a24, 'DES'), $5ccd3f34ffab67cd$export$572242e58bd07594, 'CS'), $5ccd3f34ffab67cd$export$4c29d0d04c15e55d, 'HR'), $5ccd3f34ffab67cd$export$e4824f74b9879164, 'MKT'), $5ccd3f34ffab67cd$export$4f3cb0844009af52, 'OPS'), $5ccd3f34ffab67cd$export$1a65d50c4a641bb4, 'SAL'), $5ccd3f34ffab67cd$export$3950f7f841bf94b6, 'FNC'), $5ccd3f34ffab67cd$export$881249b988b6030f, 'LGL'), (0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)($5ccd3f34ffab67cd$var$_productQueryParamTea, $5ccd3f34ffab67cd$export$cbc0e551d91a692d, 'OTR'), $5ccd3f34ffab67cd$export$4f54a09a24fd1d74, 'PDM'), $5ccd3f34ffab67cd$export$79685802e8ff1098, 'PJM'), $5ccd3f34ffab67cd$export$9ee64e8fbd8b03a2, 'DS'));
var $5ccd3f34ffab67cd$export$e93f47abc92c60f6 = function getProductQueryParamTeamType(teamType) {
    for(var _i = 0, _Object$entries = Object.entries($5ccd3f34ffab67cd$export$d9b98775fefed139); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $bYphe.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (key === teamType) return value;
    }
    return teamType;
};
var $5ccd3f34ffab67cd$export$47e4406b75d4e3e6 = function getIconForTransparentTemplateV2(teamType) {
    switch(teamType){
        case $5ccd3f34ffab67cd$export$b8b1ac856ba1434b:
            return 0, $jYP3P.SoftwareDevelopmentHeaderIcon;
        case $5ccd3f34ffab67cd$export$d7de553940261eba:
            return 0, $jYP3P.ITSupportHeaderIcon;
        case $5ccd3f34ffab67cd$export$e5c438b7501b5a24:
            return 0, $jYP3P.DesignHeaderIcon;
        case $5ccd3f34ffab67cd$export$572242e58bd07594:
            return 0, $jYP3P.CustomerServiceHeaderIcon;
        case $5ccd3f34ffab67cd$export$4c29d0d04c15e55d:
            return 0, $jYP3P.HumanResourcesHeaderIcon;
        case $5ccd3f34ffab67cd$export$e4824f74b9879164:
            return 0, $jYP3P.MarketingHeaderIcon;
        case $5ccd3f34ffab67cd$export$4f3cb0844009af52:
            return 0, $jYP3P.OperationsHeaderIcon;
        case $5ccd3f34ffab67cd$export$1a65d50c4a641bb4:
            return 0, $jYP3P.SalesHeaderIcon;
        case $5ccd3f34ffab67cd$export$3950f7f841bf94b6:
            return 0, $jYP3P.FinanceHeaderIcon;
        case $5ccd3f34ffab67cd$export$881249b988b6030f:
            return 0, $jYP3P.LegalHeaderIcon;
        case $5ccd3f34ffab67cd$export$cbc0e551d91a692d:
            return 0, $jYP3P.OtherHeaderIcon;
        case $5ccd3f34ffab67cd$export$4f54a09a24fd1d74:
            return 0, $jYP3P.ProductManagementHeaderIcon;
        case $5ccd3f34ffab67cd$export$79685802e8ff1098:
            return 0, $jYP3P.ProjectManagementHeaderIcon;
        case $5ccd3f34ffab67cd$export$9ee64e8fbd8b03a2:
            return 0, $jYP3P.DataScienceHeaderIcon;
        default:
            return null;
    }
};
var $5ccd3f34ffab67cd$export$241841e14023c14a = function getTeamTypeForTransparentTemplateV2(teamType, formatMessage) {
    switch(teamType){
        case $5ccd3f34ffab67cd$export$b8b1ac856ba1434b:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.softwareDevelopment',
                defaultMessage: 'Software development'
            });
        case $5ccd3f34ffab67cd$export$d7de553940261eba:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.itSupport',
                defaultMessage: 'IT support'
            });
        case $5ccd3f34ffab67cd$export$e5c438b7501b5a24:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.design',
                defaultMessage: 'Design'
            });
        case $5ccd3f34ffab67cd$export$572242e58bd07594:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.customerService',
                defaultMessage: 'Customer service'
            });
        case $5ccd3f34ffab67cd$export$4c29d0d04c15e55d:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.humanResources',
                defaultMessage: 'Human resources'
            });
        case $5ccd3f34ffab67cd$export$e4824f74b9879164:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.marketing',
                defaultMessage: 'Marketing'
            });
        case $5ccd3f34ffab67cd$export$4f3cb0844009af52:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.operations',
                defaultMessage: 'Operations'
            });
        case $5ccd3f34ffab67cd$export$1a65d50c4a641bb4:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.sales',
                defaultMessage: 'Sales'
            });
        case $5ccd3f34ffab67cd$export$3950f7f841bf94b6:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.finance',
                defaultMessage: 'Finance'
            });
        case $5ccd3f34ffab67cd$export$881249b988b6030f:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.legal',
                defaultMessage: 'Legal'
            });
        case $5ccd3f34ffab67cd$export$cbc0e551d91a692d:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.otherOrPersonal',
                defaultMessage: 'Other'
            });
        case $5ccd3f34ffab67cd$export$4f54a09a24fd1d74:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.productManagement',
                defaultMessage: 'Product management'
            });
        case $5ccd3f34ffab67cd$export$79685802e8ff1098:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.projectManagement',
                defaultMessage: 'Project management'
            });
        case $5ccd3f34ffab67cd$export$9ee64e8fbd8b03a2:
            return formatMessage({
                id: 'TeamTypeSurvey.teamTypeSelection.dataScience',
                defaultMessage: 'Data science'
            });
        default:
            return teamType;
    }
};
var $5ccd3f34ffab67cd$export$9b10a383fdd95886 = (0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)({}, $5ccd3f34ffab67cd$export$4c29d0d04c15e55d, [
    $5ccd3f34ffab67cd$export$390f94ade23c5f40
]), $5ccd3f34ffab67cd$export$3950f7f841bf94b6, [
    $5ccd3f34ffab67cd$export$390f94ade23c5f40
]), $5ccd3f34ffab67cd$export$881249b988b6030f, [
    $5ccd3f34ffab67cd$export$390f94ade23c5f40
]), $5ccd3f34ffab67cd$export$e4824f74b9879164, [
    $5ccd3f34ffab67cd$export$390f94ade23c5f40
]), $5ccd3f34ffab67cd$export$4f3cb0844009af52, [
    $5ccd3f34ffab67cd$export$390f94ade23c5f40
]), $5ccd3f34ffab67cd$export$1a65d50c4a641bb4, [
    $5ccd3f34ffab67cd$export$390f94ade23c5f40
]), $5ccd3f34ffab67cd$export$b8b1ac856ba1434b, [
    $5ccd3f34ffab67cd$var$USER_SEGMENTATION_ROLE_DESIGNER
]);
var $5ccd3f34ffab67cd$export$b07956d58f1245f1 = [
    $5ccd3f34ffab67cd$export$4c29d0d04c15e55d,
    $5ccd3f34ffab67cd$export$3950f7f841bf94b6,
    $5ccd3f34ffab67cd$export$881249b988b6030f,
    $5ccd3f34ffab67cd$export$e4824f74b9879164,
    $5ccd3f34ffab67cd$export$4f3cb0844009af52,
    $5ccd3f34ffab67cd$export$1a65d50c4a641bb4,
    $5ccd3f34ffab67cd$export$b8b1ac856ba1434b
];
var $5ccd3f34ffab67cd$export$b33247277ad6a292 = [
    $5ccd3f34ffab67cd$export$572242e58bd07594,
    $5ccd3f34ffab67cd$export$d7de553940261eba,
    $5ccd3f34ffab67cd$export$4c29d0d04c15e55d,
    $5ccd3f34ffab67cd$export$3950f7f841bf94b6,
    $5ccd3f34ffab67cd$export$881249b988b6030f,
    $5ccd3f34ffab67cd$export$e4824f74b9879164,
    $5ccd3f34ffab67cd$export$4f3cb0844009af52,
    $5ccd3f34ffab67cd$export$1a65d50c4a641bb4,
    $5ccd3f34ffab67cd$export$b8b1ac856ba1434b,
    $5ccd3f34ffab67cd$export$e5c438b7501b5a24,
    $5ccd3f34ffab67cd$export$4f54a09a24fd1d74,
    $5ccd3f34ffab67cd$export$79685802e8ff1098,
    $5ccd3f34ffab67cd$export$9ee64e8fbd8b03a2,
    $5ccd3f34ffab67cd$export$cbc0e551d91a692d,
    $5ccd3f34ffab67cd$export$53d2a515d824b589
];
var $5ccd3f34ffab67cd$export$3709503ef3102dbe = ($5ccd3f34ffab67cd$var$_USER_SEGMENTATION_CL = {}, (0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)($5ccd3f34ffab67cd$var$_USER_SEGMENTATION_CL, $5ccd3f34ffab67cd$export$79685802e8ff1098, [
    'Project Management'
]), $5ccd3f34ffab67cd$export$4f54a09a24fd1d74, [
    'Product Management'
]), $5ccd3f34ffab67cd$export$9ee64e8fbd8b03a2, [
    'Data Science'
]), $5ccd3f34ffab67cd$export$cbc0e551d91a692d, [
    'Other or Personal'
]), $5ccd3f34ffab67cd$var$USER_SEGMENTATION_ROLE_DESIGNER, [
    'Designer',
    'Disainer',
    "Dise\xf1ador",
    'Formgivare',
    "Nh\xe0 thi\u1EBFt k\u1EBF",
    'Projektant',
    'Suunnittelija',
    "Tasar\u0131mc\u0131",
    "Tervez\u0151",
    "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
    "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
    "\u30C7\u30B6\u30A4\u30CA\u30FC",
    "\u8A2D\u8A08\u5E2B",
    "\u8BBE\u8BA1\u5E08",
    "\uB514\uC790\uC774\uB108"
]), $5ccd3f34ffab67cd$export$e5c438b7501b5a24, [
    'Design'
]), $5ccd3f34ffab67cd$export$572242e58bd07594, [
    'Asiakaspalvelu',
    'Atendimento ao cliente',
    'Customer Service',
    "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
    'Klantenservice',
    'Klienditeenindus',
    'Kundenservice',
    'Kundeservice',
    'Kundservice',
    "M\xfc\u015Fteri Hizmetleri",
    "Obs\u0142uga klienta",
    "Service \xe0 la client\xe8le",
    "Servicio de atenci\xf3n al cliente",
    'Servizio clienti',
    "Servi\xe7o de apoio ao cliente",
    "Z\xe1kaznick\xfd servis",
    "Z\xe1kazn\xedcky servis",
    "\xdcgyf\xe9lszolg\xe1lati",
    "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
    "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
    "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
    "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
    "\u5BA2\u6237\u670D\u52A1",
    "\u9867\u5BA2\u670D\u52D9",
    "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
]), $5ccd3f34ffab67cd$export$d7de553940261eba, [
    'Assistenza IT',
    "BT Deste\u011Fi",
    "H\u1ED7 tr\u1EE3 CNTT",
    'IT',
    'IT Support',
    'IT podpora',
    "IT \u30B5\u30DD\u30FC\u30C8",
    "IT \u652F\u6301",
    "IT \u652F\u63F4",
    "IT \uC9C0\uC6D0",
    'IT_Support',
    "IT_st\xf8tte",
    'IT_support',
    'IT_tugi',
    'IT_tuki',
    "Informatikai t\xe1mogat\xe1si",
    'Soporte de TI',
    'Suporte de TI',
    "Support\xa0IT",
    'Wsparcie IT',
    "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
    "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
    "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
]), $5ccd3f34ffab67cd$export$3950f7f841bf94b6, [
    'Ekonomi',
    'Finance',
    'Financeiro',
    'Financie',
    'Finans',
    'Finanse',
    'Finants',
    'Finanza',
    'Finanzas',
    'Finanzen',
    "Finan\xe7as",
    "P\xe9nz\xfcgyi",
    'Rahoitus',
    "T\xe0i ch\xednh",
    "\xd8konomi",
    "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
    "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
    "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
    "\u8CA1\u52D9",
    "\u91D1\u878D",
    "\uC7AC\uBB34"
]), $5ccd3f34ffab67cd$export$4c29d0d04c15e55d, [
    'HR',
    "Henkil\xf6st\xf6hallinto",
    'Human Resources',
    'Human resources',
    'human-resources',
    // for Upaas
    "Lidsk\xe9 zdroje",
    'Menneskelige ressourcer',
    "Nh\xe2n s\u1EF1",
    'Personal',
    "Personalfr\xe5gor",
    'RH',
    'Recursos Humanos',
    'Recursos humanos',
    'Risorse umane',
    "Szem\xe9lyzeti",
    'Zasoby ludzkie',
    "\u0130nsan Kaynaklar\u0131",
    "\u013Dudsk\xe9 zdroje",
    "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
    "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
    "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
    "\u4EBA\u4E8B",
    "\u4EBA\u529B\u8CC7\u6E90",
    "\u4EBA\u529B\u8D44\u6E90",
    "\uC778\uC0AC"
]), (0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)((0, $cnzEg.default)($5ccd3f34ffab67cd$var$_USER_SEGMENTATION_CL, $5ccd3f34ffab67cd$export$881249b988b6030f, [
    "Departamento jur\xeddico",
    'Hukuk',
    'Jogi',
    'Jura',
    'Juridik',
    'Juridisk',
    "Jur\xeddico",
    'Legal',
    'Legale',
    'Oikeudelliset asiat',
    "Ph\xe1p l\xfd",
    'Prawo',
    "Pr\xe1vne oddelenie",
    "Pr\xe1vn\xed odd\u011Blen\xed",
    'Rechtliches',
    'Service juridique',
    "\xd5igus",
    "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
    "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
    "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
    "\u6CD5\u52D9",
    "\u6CD5\u5F8B",
    "\uBC95\uB960"
]), $5ccd3f34ffab67cd$export$e4824f74b9879164, [
    "Markedsf\xf8ring",
    'Marketing',
    'Markkinointi',
    "Marknadsf\xf6ring",
    'Pazarlama',
    "Ti\u1EBFp th\u1ECB",
    'Turundus',
    "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
    "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
    "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
    "\u8425\u9500",
    "\u884C\u92B7",
    "\uB9C8\uCF00\uD305"
]), $5ccd3f34ffab67cd$export$4f3cb0844009af52, [
    'Drift',
    'Haldus',
    'Operacional',
    'Operaciones',
    'Operacje',
    'Operasyonlar',
    'Operations',
    'Operativer Betrieb',
    'Operazioni',
    "Opera\xe7\xf5es",
    "Op\xe9rations",
    "Prev\xe1dzka",
    'Provoz',
    'Toiminnot',
    "V\u1EADn h\xe0nh",
    "\xdczemeltet\xe9si",
    "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
    "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
    "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
    "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
    "\u71DF\u904B",
    "\u8FD0\u8425",
    "\uC6B4\uC601"
]), $5ccd3f34ffab67cd$export$1a65d50c4a641bb4, [
    "B\xe1n h\xe0ng",
    "F\xf6rs\xe4ljning",
    'Myynti',
    "M\xfc\xfck",
    'Predaj',
    'Prodej',
    'Sales',
    'Salg',
    "Sat\u0131\u015F",
    "Sprzeda\u017C",
    'Vendas',
    'Vendite',
    'Ventas',
    'Ventes',
    'Vertrieb',
    "\xc9rt\xe9kes\xedt\xe9si",
    "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
    "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
    "\u30BB\u30FC\u30EB\u30B9",
    "\u92B7\u552E",
    "\u9500\u552E",
    "\uC601\uC5C5"
]), $5ccd3f34ffab67cd$export$b8b1ac856ba1434b, [
    'Desarrollo de software',
    'Desenvolvimento de software',
    "D\xe9veloppement logiciel",
    'Ohjelmistokehitys',
    "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
    'Programutveckling',
    'Programvareutvikling',
    'Software Development',
    'Softwareentwicklung',
    'Softwareontwikkeling',
    'Softwareudvikling',
    'Sviluppo software',
    "Szoftverfejleszt\u0151",
    'Tarkvaraarendus',
    'Tworzenie oprogramowania',
    "V\xfdvoj softv\xe9ru",
    "V\xfdvoj softwaru",
    "Yaz\u0131l\u0131m Geli\u015Ftirme",
    "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
    "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
    "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
    "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
    "\u8EDF\u9AD4\u958B\u767C",
    "\u8F6F\u4EF6\u5F00\u53D1",
    "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
]));

});
parcelRegister("bYphe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8b78e7cd0c842768$export$2e2bcd8739ae039; });

var $bQvcd = parcelRequire("bQvcd");

var $iz0Sg = parcelRequire("iz0Sg");

var $92i4b = parcelRequire("92i4b");

var $8za3Q = parcelRequire("8za3Q");
function $8b78e7cd0c842768$export$2e2bcd8739ae039(r, e) {
    return (0, $bQvcd.default)(r) || (0, $iz0Sg.default)(r, e) || (0, $92i4b.default)(r, e) || (0, $8za3Q.default)();
}

});
parcelRegister("bQvcd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $89fcbfeaccc7d519$export$2e2bcd8739ae039; });
function $89fcbfeaccc7d519$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("iz0Sg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d83c2c77494c2314$export$2e2bcd8739ae039; });
function $d83c2c77494c2314$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("92i4b", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69425098ef0a5137$export$2e2bcd8739ae039; });

var $dFKoU = parcelRequire("dFKoU");
function $69425098ef0a5137$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $dFKoU.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $dFKoU.default)(r, a) : void 0;
    }
}

});
parcelRegister("dFKoU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f4318e7ba0da670$export$2e2bcd8739ae039; });
function $9f4318e7ba0da670$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("8za3Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63c9658997d913b1$export$2e2bcd8739ae039; });
function $63c9658997d913b1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("cnzEg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9033490f2cd9bb48$export$2e2bcd8739ae039; });

var $cGn72 = parcelRequire("cGn72");
function $9033490f2cd9bb48$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $cGn72.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("cGn72", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $93bb55f6d39d7c31$export$2e2bcd8739ae039; });

var $7oJLJ = parcelRequire("7oJLJ");

var $fXoHZ = parcelRequire("fXoHZ");
function $93bb55f6d39d7c31$export$2e2bcd8739ae039(t) {
    var i = (0, $fXoHZ.default)(t, "string");
    return "symbol" == (0, $7oJLJ.default)(i) ? i : i + "";
}

});
parcelRegister("7oJLJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $562e47101d49f5df$export$2e2bcd8739ae039; });
function $562e47101d49f5df$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $562e47101d49f5df$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $562e47101d49f5df$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fXoHZ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b9df884ebd7fbeb0$export$2e2bcd8739ae039; });

var $7oJLJ = parcelRequire("7oJLJ");
function $b9df884ebd7fbeb0$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7oJLJ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7oJLJ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("jYP3P", function(module, exports) {
$parcel$export(module.exports, "SoftwareDevelopmentHeaderIcon", function () { return $e8bb3a80267c3ab3$export$e11bc36dd8a99125; });
$parcel$export(module.exports, "ProductManagementHeaderIcon", function () { return $e8bb3a80267c3ab3$export$72976b44f07f811b; });
$parcel$export(module.exports, "MarketingHeaderIcon", function () { return $e8bb3a80267c3ab3$export$bfad4d4e8f73e77e; });
$parcel$export(module.exports, "DesignHeaderIcon", function () { return $e8bb3a80267c3ab3$export$d3f781ec209b4fd7; });
$parcel$export(module.exports, "ProjectManagementHeaderIcon", function () { return $e8bb3a80267c3ab3$export$bababd42ef961024; });
$parcel$export(module.exports, "OperationsHeaderIcon", function () { return $e8bb3a80267c3ab3$export$6efd0fa33b4aa14d; });
$parcel$export(module.exports, "ITSupportHeaderIcon", function () { return $e8bb3a80267c3ab3$export$6c12f9ab3896c60b; });
$parcel$export(module.exports, "HumanResourcesHeaderIcon", function () { return $e8bb3a80267c3ab3$export$6de851e46e3b87af; });
$parcel$export(module.exports, "CustomerServiceHeaderIcon", function () { return $e8bb3a80267c3ab3$export$ab663870e0e1a3cd; });
$parcel$export(module.exports, "LegalHeaderIcon", function () { return $e8bb3a80267c3ab3$export$3fb457a290d0178f; });
$parcel$export(module.exports, "FinanceHeaderIcon", function () { return $e8bb3a80267c3ab3$export$1b11a71dd9d8f914; });
$parcel$export(module.exports, "SalesHeaderIcon", function () { return $e8bb3a80267c3ab3$export$f2bd611053c3be8a; });
$parcel$export(module.exports, "DataScienceHeaderIcon", function () { return $e8bb3a80267c3ab3$export$f7c6a6f312b0247; });
$parcel$export(module.exports, "OtherHeaderIcon", function () { return $e8bb3a80267c3ab3$export$f8101b6de63ddffb; });

var $1oC0p = parcelRequire("1oC0p");

var $fAV5E = parcelRequire("fAV5E");
var $e8bb3a80267c3ab3$var$ITSupportGlyph = function ITSupportGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "33",
        viewBox: "0 0 31 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.53125 6.25V32.125L8.025 25.7H30.5187V6.25H0.53125Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M13.8496 7.01855C13.8496 5.1623 15.3309 3.6748 17.1621 3.6748C18.9934 3.6748 20.4746 5.15605 20.4746 7.01855C20.4746 7.9623 20.2496 8.39355 20.0434 8.66855C19.7996 8.9873 19.4934 9.2123 18.9559 9.60605C18.8684 9.6748 18.7684 9.74355 18.6621 9.81855C17.9934 10.3123 17.1434 10.9873 16.5059 12.1061C15.8621 13.2311 15.5059 14.6436 15.5059 16.5123H18.8184C18.8184 15.0623 19.0871 14.2561 19.3746 13.7623C19.6621 13.2561 20.0559 12.9123 20.6309 12.4873C20.6996 12.4373 20.7746 12.3811 20.8559 12.3248C21.3746 11.9498 22.1121 11.4186 22.6684 10.6873C23.3871 9.7498 23.7871 8.5748 23.7871 7.01855C23.7871 3.35605 20.8496 0.362305 17.1621 0.362305C13.4746 0.362305 10.5371 3.35605 10.5371 7.01855V8.67481H13.8496V7.01855Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M17.1625 19.0063C16.0188 19.0063 15.0938 19.9313 15.0938 21.0751C15.0938 22.2188 16.0188 23.1438 17.1625 23.1438C18.3063 23.1438 19.2313 22.2188 19.2313 21.0751C19.2313 19.9313 18.3063 19.0063 17.1625 19.0063Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.575 6.25H13.9375C13.875 6.49375 13.8437 6.75625 13.8437 7.01875V8.675H10.5312V7.01875C10.5312 6.7625 10.5437 6.50625 10.575 6.25Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.2312 21.0749C19.2312 22.2186 18.3062 23.1499 17.1624 23.1499C16.0187 23.1499 15.0874 22.2186 15.0874 21.0749C15.0874 19.9311 16.0187 19.0061 17.1624 19.0061C18.3062 19.0061 19.2312 19.9311 19.2312 21.0749Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.7871 7.01875C23.7871 8.58125 23.3871 9.75 22.6684 10.6875C22.1121 11.4187 21.3746 11.95 20.8559 12.325C20.7746 12.3875 20.6996 12.4375 20.6309 12.4875C20.0559 12.9187 19.6621 13.2625 19.3746 13.7687C19.0871 14.2687 18.8184 15.075 18.8184 16.5188H15.5059C15.5059 14.65 15.8559 13.2375 16.4996 12.1187C17.1434 11 17.9934 10.325 18.6559 9.825C18.7621 9.75 18.8621 9.68125 18.9496 9.6125C19.4934 9.2125 19.7934 8.99375 20.0371 8.675C20.2496 8.39375 20.4746 7.9625 20.4746 7.01875C20.4746 6.75625 20.4434 6.49375 20.3809 6.25H23.7434C23.7746 6.50625 23.7871 6.7625 23.7871 7.01875Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$var$DesignGlyph = function DesignGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M27.6437 19.644C27.7437 19.0877 27.7938 18.4877 27.7938 17.8627C27.7938 17.2377 27.7438 16.6252 27.6375 16.0565C27.0313 12.6877 24.6938 10.6127 21.4062 10.0752C20.8438 9.98149 20.2563 9.93774 19.65 9.93774C19.0438 9.93774 18.4 9.98775 17.8188 10.0877C14.5375 10.6377 12.2 12.7065 11.5938 16.0565C11.4938 16.6252 11.4375 17.2252 11.4375 17.8627C11.4375 18.5002 11.4875 19.0877 11.5875 19.644C12.1875 22.9877 14.525 25.0627 17.8188 25.6127C18.4 25.7127 19.0125 25.7627 19.65 25.7627C20.2875 25.7627 20.85 25.719 21.4062 25.6252C24.6938 25.0877 27.0375 23.0127 27.6375 19.644H27.6437Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M0.556152 16.9752L10.3062 0.262695L20.0562 16.9752H0.556152Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M16.2687 10.4875C13.8062 11.35 12.0937 13.2563 11.5937 16.0563C11.5375 16.3563 11.5 16.6563 11.4688 16.975H20.05L16.2687 10.4875Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M34.3748 19.3252H20.6748V33.0252H34.3748V19.3252Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M20.6748 19.3311V25.7186C20.9248 25.6936 21.1686 25.6623 21.4123 25.6248C24.6998 25.0936 27.0373 23.0123 27.6436 19.6436C27.6623 19.5436 27.6811 19.4373 27.6936 19.3311H20.6748Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$var$SoftwareDevelopmentGlyph = function SoftwareDevelopmentGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "31",
        viewBox: "0 0 35 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M34.9626 0.581299H0.0375977V23.45H34.9626V0.581299Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M26.8816 26.5812V30.4687H8.11914V26.5812H14.3691V19.6062H20.6316V26.5812H26.8816Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M20.6316 19.6062H14.3691V23.4562H20.6316V19.6062Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M17.4997 17.4438C20.4959 17.4438 22.9247 15.0149 22.9247 12.0188C22.9247 9.02261 20.4959 6.59375 17.4997 6.59375C14.5036 6.59375 12.0747 9.02261 12.0747 12.0188C12.0747 15.0149 14.5036 17.4438 17.4997 17.4438Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$a8475ed0ad467766 = function MarketingGlpyh() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "28",
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M28.5936 0.362549L14.9561 5.8188V20.3688L28.5936 25.825V0.362549Z",
        fill: "#1868DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M18.45 6.72485V19.4374H11.3187V27.6374H5.8625V19.4374H0.40625V6.72485H18.45Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M18.4498 6.72485H14.9561V19.4311H18.4498V6.72485Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$7a5074cf88127a64 = function OperationsGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "37",
        viewBox: "0 0 42 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3371 0.553483L22.3053 0.585025L24.7811 7.28206L31.8316 6.13992L35.7841 13.0563L31.2273 18.5555L35.7405 24.082L31.7333 30.9669L24.7007 29.769L22.1719 36.4462L14.2037 36.4147L11.7278 29.7176L4.68588 30.8598L0.733372 23.9434L5.29013 18.4528L0.776983 12.9263L4.78412 6.04139L11.8253 7.23932L14.3541 0.562091L14.3371 0.553483ZM18.2193 25.2168C21.9344 25.2315 24.9525 22.2372 24.9672 18.5221C24.9819 14.8071 21.9876 11.7889 18.2726 11.7742C14.5575 11.7595 11.5394 14.7539 11.5247 18.4689C11.5099 22.184 14.5043 25.2021 18.2193 25.2168Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.2269 18.547L35.7836 13.0564L31.8311 6.13999L24.7807 7.28213L22.3048 0.593637L14.3366 0.562095L11.7993 7.23075L4.76661 6.03286L0.759472 12.9177L5.27262 18.4442L0.715827 23.9434L4.66834 30.8598L11.7103 29.7091L14.1947 36.4061L22.1629 36.4377L24.6917 29.7605L28.5665 30.4249L31.7329 30.9669L35.74 24.082L33.9382 21.8714L31.2269 18.547ZM18.2189 25.2169C14.5123 25.2022 11.5095 22.1841 11.5242 18.469C11.5389 14.7539 14.5656 11.7596 18.2721 11.7743C21.9786 11.789 24.9814 14.8157 24.9668 18.5222C24.9521 22.2287 21.9339 25.2316 18.2189 25.2169Z",
        fill: "#FFA900"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        style: {
            mixBlendMode: 'multiply'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M41.3728 26.2112C41.4574 25.7407 41.4997 25.2333 41.4997 24.7047C41.4997 24.1761 41.4574 23.6581 41.3675 23.1771C40.8548 20.328 38.8779 18.5731 36.0975 18.1185C35.6218 18.0392 35.1249 18.0022 34.6122 18.0022C34.0994 18.0022 33.555 18.0445 33.0634 18.1291C30.2883 18.5942 28.3114 20.3438 27.7987 23.1771C27.7141 23.6581 27.6665 24.1655 27.6665 24.7047C27.6665 25.2439 27.7088 25.7407 27.7934 26.2112C28.3008 29.0391 30.2777 30.794 33.0634 31.2592C33.555 31.3438 34.073 31.386 34.6122 31.386C35.1513 31.386 35.627 31.349 36.0975 31.2698C38.8779 30.8152 40.8601 29.0603 41.3675 26.2112H41.3728Z",
        fill: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.4713 18.4998L35.7119 23.6925L35.9706 24.0099L31.9635 30.8948L31.9371 30.8903L31.7897 30.865C29.6821 30.132 28.2195 28.5139 27.7934 26.1389C27.7088 25.6685 27.6665 25.1716 27.6665 24.6325C27.6665 24.0933 27.7141 23.5859 27.7987 23.1048C28.2069 20.8492 29.5431 19.2804 31.4713 18.4998Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.225 22.6846L33.5824 28.0872L30.667 25.2185L31.9257 24.0494L33.6039 25.6975L37.9878 21.5L39.2304 22.6897L39.225 22.6846Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$5a330511b92aac24 = function PeopleAndOtherGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "38",
        viewBox: "0 0 43 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M18.3876 3.30908C8.50444 3.30908 0.5 11.3214 0.5 21.1967C0.5 28.6407 5.0469 35.0269 11.5199 37.7187V33.4007C11.5199 29.6038 14.5986 26.533 18.3876 26.533C22.1767 26.533 25.2475 29.6116 25.2475 33.4007V37.7187C31.7205 35.0348 36.2753 28.6486 36.2753 21.1967C36.2753 11.3135 28.2629 3.30908 18.3876 3.30908ZM18.3876 24.599C15.1353 24.599 12.4988 21.9624 12.4988 18.7101C12.4988 15.4578 15.1274 12.8213 18.3876 12.8213C21.6478 12.8213 24.2686 15.4499 24.2686 18.7101C24.2686 21.9703 21.6399 24.599 18.3876 24.599Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M29.447 6.64839L23.1318 9.80597L29.447 12.9635L32.6045 19.2787L35.7621 12.9635L42.0773 9.80597L35.7621 6.64839L32.6045 0.333252L29.447 6.64839Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M34.9811 14.5266L32.605 19.2787L29.4475 12.9636L23.1323 9.80601L29.0607 6.83789C31.6814 8.79558 33.7497 11.4479 34.9811 14.5266Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M29.0607 6.83789L23.1323 9.80601L29.4475 12.9636L32.605 19.2787L34.9811 14.5266C33.7497 11.4479 31.6814 8.79558 29.0607 6.83789Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$2a1d70df8da1fa8a = function SalesGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "34",
        viewBox: "0 0 26 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.6161 33.4709H0V0H12.9505L25.6161 12.4757V33.4709Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M12.9453 0V12.4388H25.5793L12.9453 0Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M20.0179 16.543H12.9492V20.0773H20.0179V16.543Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M8.2369 20.6681C9.53918 20.6681 10.5949 19.6124 10.5949 18.3101C10.5949 17.0079 9.53918 15.9521 8.2369 15.9521C6.93462 15.9521 5.87891 17.0079 5.87891 18.3101C5.87891 19.6124 6.93462 20.6681 8.2369 20.6681Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M20.0179 25.458H12.9492V28.9924H20.0179V25.458Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M8.2369 29.5832C9.53918 29.5832 10.5949 28.5275 10.5949 27.2252C10.5949 25.9229 9.53918 24.8672 8.2369 24.8672C6.93462 24.8672 5.87891 25.9229 5.87891 27.2252C5.87891 28.5275 6.93462 29.5832 8.2369 29.5832Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$c3c91f9d6f32ce98 = function CustomerServiceGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "46",
        height: "28",
        viewBox: "0 0 46 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M45.5573 10.3687H11.3848V27.0656H45.5573V10.3687Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M34.9362 0H0.763672V16.6969H34.9362V0Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M34.9358 10.3687H11.3848V16.6966H34.9358V10.3687Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2535 5.66825L6.8942 13.0275L3.0918 9.11988L4.73342 7.52736L6.92226 9.77232L12.6399 4.05469L14.2605 5.67527L14.2535 5.66825Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M43.4312 16.4021L36.0719 23.7614L32.2695 19.8538L33.9112 18.2612L36.1 20.5062L41.8176 14.7886L43.4382 16.4092L43.4312 16.4021Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$a9941a16640f105a = function FinanceGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "30",
        viewBox: "0 0 36 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M35.9463 18.2911V14.6985C35.9463 13.7694 35.1039 13.0137 34.057 13.0137H12.8853C11.8385 13.0137 10.9961 13.7632 10.9961 14.6985V18.2911H35.9463Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M35.9463 20.6449H10.9961V28.0408C10.9961 28.9637 11.8385 29.7256 12.8853 29.7256H34.057C35.1039 29.7256 35.9463 28.9699 35.9463 28.0408V20.6449Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.7685 5.27746V1.68482C25.7685 0.75569 24.9261 0 23.8793 0H2.70759C1.66077 0 0.818359 0.749496 0.818359 1.68482V5.27746H25.7685Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.7685 7.63125H0.818359V15.0271C0.818359 15.95 1.66077 16.7119 2.70759 16.7119H23.8793C24.9261 16.7119 25.7685 15.9562 25.7685 15.0271V7.63125Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$b81d861c2dc0475e = function HrGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "33",
        viewBox: "0 0 27 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M27 5.5H0V32.9999H27V5.5Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M7 27.844C7 25.6275 9.9081 23.833 13.5 23.833C17.0919 23.833 20 25.6275 20 27.844V32.9996H7V27.844Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M18 17.875C18 20.1498 15.988 22 13.5 22C11.012 22 9 20.1556 9 17.875C9 15.5943 11.012 13.75 13.5 13.75C15.988 13.75 18 15.5943 18 17.875Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M23 3.25947V10.0833H4V3.25947H9.58471C9.58471 1.45789 11.3374 0 13.5033 0C15.6692 0 17.4153 1.45789 17.4153 3.25947H23Z",
        fill: "#0C66E4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M23 5.5H4V10.0833H23V5.5Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$f2de52c1920eba82 = function LegalGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 275 275",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M53.72 68.75L43.27 229.76H223.49L229.02 68.75H53.72Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.3799 203.36L31.5199 186.23H200.17L207.6 203.36H31.3799Z",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.5199 186.23L31.3799 203.36H44.9899L46.0999 186.23H31.5199Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M194.57 146.02L243.17 50.7L229.24 43.79L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M129.43 164.74C130.22 166.72 130.29 169.1 130.74 171.52L130.83 172.09C130.91 172.46 130.99 173 131.3 173.68C131.47 174.02 131.68 174.4 132.05 174.74C132.4 175.1 132.92 175.34 133.43 175.48C134.49 175.69 135.48 175.49 136.46 175.17C138.52 174.44 139.95 172.74 141.15 171.38C142.35 169.98 143.45 168.84 144.42 168.25C145.7 167.65 147.21 167.65 148.67 167.89C150.14 168.13 151.6 168.6 153.11 169.01C156.15 169.83 159.36 170.14 162.52 169.85C162.52 169.85 164.5 169.62 166.67 169C168.85 168.41 171.22 167.53 172.28 167.03C173.6 166.39 174.42 165.87 174.55 165.58C174.68 165.28 174.08 165.22 172.56 165.52C171.04 165.8 168.64 166.57 165.14 167.41C165.05 167.4 164.76 167.43 164.72 167.39C161.04 168.32 157.29 168.13 153.72 167.12C151.91 166.62 150.01 165.89 147.75 165.7C146.63 165.61 145.42 165.68 144.21 166.1C142.99 166.52 141.99 167.26 141.17 168.01C141.36 168.04 141.2 168.32 140.97 168.45L140.91 168.25C139.92 169.33 139.16 170.28 138.4 171.05C137.65 171.82 136.92 172.41 136.2 172.76C135.56 173.08 134.52 173.33 134.01 173.27C133.74 173.24 133.63 173.22 133.43 173.06C133.23 172.89 133 172.51 132.8 172.03C132.8 172.05 133.16 172.41 133.16 172.4C132.9 171.66 132.79 170.63 132.69 169.58C132.59 168.51 132.5 167.37 132.31 166.17C132.1 164.97 131.8 163.69 131.1 162.45C130.44 161.2 129.23 160.1 127.89 159.53L126.89 159.18L126.39 159.01L125.86 158.92L124.79 158.77L123.71 158.8C123.53 158.8 123.35 158.81 123.17 158.83L122.65 158.93C122.3 159 121.95 159.07 121.61 159.15C120.97 159.4 120.27 159.58 119.69 159.91C117.24 161.11 115.2 162.81 113.34 164.59C111.48 166.38 109.77 168.28 108.07 170.1L106.8 171.45C106.72 171.51 106.77 171.49 106.67 171.48C106.59 171.42 106.59 171.44 106.59 171.36C106.69 170.78 106.8 170.2 106.9 169.62C107.79 164.8 108.86 160.11 109.85 155.68L109.8 155.76L109.78 155.71C109.49 156.51 108.82 158.84 108.23 160.98C107.65 163.12 107.16 165.07 107.16 165.07C107.35 162.03 108.1 158.89 108.98 155.73C109.87 152.57 110.82 149.39 111.63 146.28L111.85 146.38C111.13 149.07 110.68 151.47 110.54 152.47C110.87 151.27 111.23 149.92 111.63 148.46C112.04 147 112.49 145.42 112.91 143.73C113.74 140.36 114.57 136.59 114.52 132.63C114.48 130.66 114.21 128.61 113.41 126.71C112.64 124.8 111.24 123.11 109.58 122.09C108.77 121.55 107.9 121.19 107.06 120.9C106.65 120.78 106.24 120.66 105.84 120.55C105.44 120.45 105.03 120.38 104.64 120.3C103.06 120.03 101.58 120.01 100.31 120.14C100.45 120.25 101.3 120.09 102.23 120.17C102.69 120.17 103.17 120.24 103.57 120.35C103.97 120.45 104.3 120.58 104.47 120.77C101.94 120.29 99.3202 120.53 97.0202 121.14C96.9702 120.96 97.2902 120.8 97.6602 120.69C98.0302 120.6 98.4502 120.53 98.5802 120.47C98.0602 120.51 96.2302 120.75 93.7202 121.76C91.2202 122.79 88.1202 124.65 85.0802 127.33C78.9702 132.68 72.9602 141 69.1402 149.57C67.2102 153.83 65.7602 158.06 64.6002 161.79C63.4502 165.53 62.5902 168.78 61.9802 171.18C60.7802 175.98 60.6502 177.44 62.3802 172.89L62.4302 173.42C63.9102 168.63 65.1002 164.64 67.1302 159.84C67.3302 159.13 67.4002 159.07 67.2102 159C67.2502 158.81 67.3002 158.48 67.1902 158.53C66.7202 158.45 67.4302 156.97 67.6802 156.29C68.2402 156.95 69.6102 153.17 71.3702 149.12C72.2402 147.09 73.2502 145.01 74.1302 143.32C75.0202 141.64 75.7802 140.35 76.1202 139.89C76.9302 139.9 78.6802 136.25 79.8002 135.38C79.7602 135.47 79.5202 136.05 79.4902 136.13C80.0302 135.78 83.1402 131.48 86.4102 128.46C89.6402 125.39 92.8002 123.68 90.5902 125.5C93.1302 124.07 96.1002 122.77 99.3902 122.43C101.03 122.26 102.73 122.34 104.41 122.74C106.1 123.15 107.76 123.75 108.98 124.88C110.22 125.99 111.05 127.55 111.45 129.35C111.87 131.14 111.9 133.1 111.76 135.08C111.46 139.07 110.44 143.13 109.39 147.25C108.37 151.42 107.42 155.54 106.47 159.66C106 161.72 105.55 163.76 105.12 165.8C104.92 166.82 104.71 167.83 104.51 168.84C104.41 169.34 104.32 169.85 104.22 170.35L104.15 170.73L104.11 170.93L104.08 171.25C104.06 171.68 104.14 172.14 104.35 172.53C104.76 173.33 105.53 173.85 106.38 173.96C106.81 174.02 107.27 173.96 107.68 173.79C107.89 173.72 108.07 173.59 108.25 173.47C108.4 173.35 108.6 173.17 108.66 173.1C109.35 172.38 110.03 171.67 110.71 170.96C112.04 169.55 113.34 168.19 114.65 166.95C117.24 164.48 120.06 162.42 122.72 161.92L122.54 161.87C122.71 161.87 123.22 161.72 123.36 161.79C123.85 161.66 124.57 161.53 125.36 161.63C126.14 161.72 127.06 161.99 127.66 162.4C128.3 162.81 128.74 163.41 129.01 163.89C129.27 164.39 129.4 164.74 129.4 164.74H129.43ZM110.79 145.61C110.79 145.61 110.76 145.57 110.75 145.58C110.83 145.58 111.58 142.38 111.61 142.25L111.84 142.32C111.53 145.68 107.99 152.76 110.51 145.84C110.51 145.59 110.71 145.63 110.8 145.6L110.79 145.61ZM103.79 121.7C103.24 121.6 102.63 121.5 101.95 121.47C103.83 121.36 105.94 121.67 107.93 122.59C109.94 123.49 111.55 125.37 112.29 127.54C113.05 129.71 113.13 132.06 113.01 134.3C112.87 136.55 112.53 138.73 112.19 140.8C111.96 139.3 112.28 136.94 112.43 134.49C112.6 132.05 112.46 129.5 111.88 127.86C111.18 126.28 110.13 124.7 108.61 123.68C107.88 123.14 107.06 122.74 106.22 122.43C105.39 122.11 104.57 121.87 103.79 121.71V121.7ZM69.5802 152.33L69.6902 152.4L69.5902 152.65C69.5902 152.65 69.5402 152.59 69.5402 152.54C69.5402 152.49 69.5502 152.4 69.5802 152.34V152.33ZM127.83 161.64C127.37 161.48 125.5 160.81 126.88 160.87C127.21 161 128.17 161.35 127.83 161.64ZM95.3602 122.35C95.4202 122.53 94.8302 122.9 94.1902 123.16C93.5702 123.45 92.8902 123.64 92.7702 123.42C93.6202 122.98 94.4902 122.64 95.3602 122.35ZM138.7 172.93C138.97 172.13 139.12 172.61 139.48 172.62C139.31 172.72 138.78 173.16 138.76 172.92H138.69L138.7 172.93ZM149.64 167.37C149.87 167.2 150.63 167.25 150.97 167.33C151.81 167.7 150 167.62 149.64 167.37ZM170.7 167.14C170.67 166.91 171.13 166.69 171.33 166.87C171.33 167.05 170.77 167.36 170.61 167.12C170.61 167.12 170.65 167.14 170.7 167.14ZM84.0902 128.88C84.1502 127.83 86.4902 126.49 87.5102 125.51C87.6702 126.22 85.4202 127.42 84.7202 128.26C84.4502 128.51 84.2402 128.72 84.0902 128.88ZM109.97 169.04C109.5 168.65 111.82 166.87 112.4 166.09L112.56 166.27C111.61 167.34 111.14 168.06 110.01 169L109.97 169.04ZM108.64 121.87C109.3 121.92 110.03 122.71 110.49 123.11C110.37 123.24 109.83 122.87 109.32 122.57C108.84 122.23 108.37 121.95 108.64 121.86V121.87ZM112.26 144.9C111.87 144.92 112.33 143.83 112.37 143.49C112.39 143.74 112.51 144.22 112.44 144.49C112.39 144.68 112.34 144.72 112.26 144.9ZM109.43 169.96C109.06 170.36 108.67 170.78 108.28 171.2C107.9 171.58 107.44 172.14 107.16 172.27L107.07 172.05C107.13 172.01 107.19 171.97 107.25 171.92C107.32 171.86 107.44 171.73 107.53 171.63L108.12 171.02C108.51 170.61 108.89 170.19 109.28 169.79L109.43 169.97V169.96ZM106.92 166.91L107.15 166.96C107.05 168.58 106.42 168.64 106.91 166.95V166.91H106.92ZM120.33 160.26C120.17 160.33 119.91 160.44 119.76 160.51C118.68 161.07 118.79 160.78 119.2 160.45C119.61 160.12 120.32 159.77 120.33 160.25V160.26ZM131.49 164.28C131.59 164.51 131.76 164.82 131.81 165.08C132.13 166.79 131.23 165.04 131.49 164.28Z",
        fill: "#333437"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M229.02 68.75H216.51L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57L228.66 79.16L229.02 68.75Z",
        fill: "#09326C"
    }));
};
var $e8bb3a80267c3ab3$export$816a17ab71a9c447 = function SoftwareDevelopment2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        id: "Frame"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        id: "Layer 1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        id: "Vector",
        d: "M31.6417 10.6006H8.3584V25.5076H31.6417V10.6006Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        id: "Vector_2",
        d: "M26.2544 27.5486V30.0827H13.7461V27.5486H17.9128V23.002H22.0878V27.5486H26.2544Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        id: "Vector_3",
        d: "M22.0881 23.002H17.9131V25.5116H22.0881V23.002Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        id: "Vector_4",
        d: "M19.9995 21.5921C21.9969 21.5921 23.6161 20.0089 23.6161 18.0558C23.6161 16.1028 21.9969 14.5195 19.9995 14.5195C18.002 14.5195 16.3828 16.1028 16.3828 18.0558C16.3828 20.0089 18.002 21.5921 19.9995 21.5921Z",
        fill: "white"
    }))));
};
var $e8bb3a80267c3ab3$export$b6c5d967ad9baf32 = function ProductManagementGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M13.6757 9.37109H17.5632L18.784 12.6336L22.2215 12.0628L24.1632 15.4294L21.9507 18.1211L24.1632 20.8086L22.2215 24.1753L18.7882 23.6044L17.5673 26.8669H13.6798L12.459 23.6044L9.02565 24.1753L7.08398 20.8086L9.29648 18.1211L7.08398 15.4336L9.02565 12.0669L12.4632 12.6378L13.684 9.37526L13.6757 9.37109ZM15.6173 21.3961C17.4298 21.3961 18.8965 19.9294 18.8965 18.1169C18.8965 16.3044 17.4298 14.8378 15.6173 14.8378C13.8048 14.8378 12.3382 16.3044 12.3382 18.1169C12.3382 19.9294 13.8048 21.3961 15.6173 21.3961Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M24.629 17.1006H27.8373L28.8456 19.7923L31.6831 19.3214L33.2873 22.1006L31.4581 24.3214L33.2831 26.5423L31.679 29.3214L28.8415 28.8506L27.8331 31.5423H24.6248L23.6165 28.8506L20.779 29.3214L19.1748 26.5423L20.9998 24.3214L19.1748 22.1006L20.779 19.3214L23.6165 19.7923L24.6248 17.1006H24.629ZM26.2331 27.0298C27.729 27.0298 28.9415 25.8173 28.9415 24.3214C28.9415 22.8256 27.729 21.6131 26.2331 21.6131C24.7373 21.6131 23.5248 22.8256 23.5248 24.3214C23.5248 25.8173 24.7373 27.0298 26.2331 27.0298Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.9502 18.1167L24.1627 15.4292L22.221 12.0625L18.7835 12.6333L17.5627 9.375H13.6752L12.4502 12.6333L9.01686 12.0625L7.0752 15.4292L9.2877 18.1167L7.0752 20.8083L9.01686 24.175L12.4502 23.6L13.6752 26.8625H17.5627L18.7835 23.6L20.6752 23.9167L22.221 24.175L24.1627 20.8083L23.2794 19.7333L21.9502 18.1167ZM15.6169 21.3958C13.8085 21.3958 12.3377 19.9292 12.3377 18.1167C12.3377 16.3042 13.8085 14.8375 15.6169 14.8375C17.4252 14.8375 18.896 16.3083 18.896 18.1167C18.896 19.925 17.4294 21.3958 15.6169 21.3958Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M23.2797 19.7338L20.7839 19.3213L19.1797 22.1005L20.6755 23.9171L22.2214 24.1755L24.163 20.8088L23.2797 19.7338Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$89a8de63b42b4bf7 = function Marketing2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M28.7919 10.4443L19.7002 14.0818V23.7818L28.7919 27.4193V10.4443Z",
        fill: "#1868DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M22.0292 14.6855V23.1605H17.275V28.6272H13.6375V23.1605H10V14.6855H22.0292Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M22.0294 14.6855H19.7002V23.1564H22.0294V14.6855Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$27ec4a87867305fc = function Design2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.4292 21.0958C25.4958 20.725 25.5292 20.325 25.5292 19.9083C25.5292 19.4917 25.4958 19.0833 25.425 18.7042C25.0208 16.4583 23.4625 15.075 21.2708 14.7167C20.8958 14.6542 20.5042 14.625 20.1 14.625C19.6958 14.625 19.2667 14.6583 18.8792 14.725C16.6917 15.0917 15.1333 16.4708 14.7292 18.7042C14.6625 19.0833 14.625 19.4833 14.625 19.9083C14.625 20.3333 14.6583 20.725 14.725 21.0958C15.125 23.325 16.6833 24.7083 18.8792 25.075C19.2667 25.1417 19.675 25.175 20.1 25.175C20.525 25.175 20.9 25.1458 21.2708 25.0833C23.4625 24.725 25.025 23.3417 25.425 21.0958H25.4292Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M7.37109 19.3165L13.8711 8.1748L20.3711 19.3165H7.37109Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M17.8465 14.9912C16.2048 15.5662 15.0631 16.837 14.7298 18.7037C14.6923 18.9037 14.6673 19.1037 14.6465 19.3162H20.3673L17.8465 14.9912Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M29.9165 20.8828H20.7832V30.0161H29.9165V20.8828Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M20.7832 20.8867V25.1451C20.9499 25.1284 21.1124 25.1076 21.2749 25.0826C23.4665 24.7284 25.0249 23.3409 25.429 21.0951C25.4415 21.0284 25.454 20.9576 25.4624 20.8867H20.7832Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$a9d1d41ede76da88 = function ProjectManagementGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M33.2743 18.1211H12.9785V28.0378H33.2743V18.1211Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M26.9667 11.9629H6.6709V21.8796H26.9667V11.9629Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M26.966 18.1211H12.9785V21.8794H26.966V18.1211Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M14.6829 15.3294L10.312 19.7003L8.05371 17.3794L9.02871 16.4336L10.3287 17.7669L13.7245 14.3711L14.687 15.3336L14.6829 15.3294Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M32.012 21.7044L27.6411 26.0753L25.3828 23.7544L26.3578 22.8086L27.6578 24.1419L31.0536 20.7461L32.0161 21.7086L32.012 21.7044Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$a10f1df78def0898 = function Operations2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M16.4783 10.0306L21.0316 10.0486L22.4464 13.8755L26.4752 13.2228L28.7338 17.175L26.1299 20.3174L28.7088 23.4754L26.419 27.4096L22.4004 26.7251L20.9553 30.5407L16.4021 30.5227L14.9873 26.6958L10.9634 27.3484L8.70478 23.3962L11.3086 20.2587L8.7297 17.1007L11.0195 13.1665L15.043 13.851L16.4881 10.0355L16.4783 10.0306ZM18.6968 24.1239C20.8197 24.1323 22.5443 22.4213 22.5527 20.2984C22.5611 18.1755 20.8501 16.4508 18.7272 16.4424C16.6043 16.434 14.8796 18.1451 14.8712 20.268C14.8628 22.3909 16.5739 24.1155 18.6968 24.1239Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M26.1299 20.3126L28.7338 17.1751L26.4752 13.2229L22.4464 13.8755L21.0316 10.0535L16.4783 10.0355L15.0284 13.8461L11.0098 13.1616L8.71998 17.0959L11.2989 20.2539L8.69504 23.3962L10.9536 27.3485L14.9776 26.6909L16.3972 30.5178L20.9505 30.5358L22.3955 26.7203L24.6097 27.0999L26.4191 27.4097L28.7088 23.4754L27.6792 22.2123L26.1299 20.3126ZM18.6968 24.1239C16.5788 24.1156 14.8628 22.3909 14.8712 20.268C14.8796 18.1451 16.6092 16.4341 18.7272 16.4425C20.8452 16.4508 22.5611 18.1804 22.5527 20.2984C22.5443 22.4164 20.8197 24.1323 18.6968 24.1239Z",
        fill: "#FFA900"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.9279 24.6918C31.9762 24.423 32.0004 24.133 32.0004 23.831C32.0004 23.5289 31.9762 23.2329 31.9248 22.958C31.6319 21.33 30.5022 20.3272 28.9134 20.0674C28.6416 20.0221 28.3576 20.001 28.0646 20.001C27.7717 20.001 27.4605 20.0251 27.1796 20.0735C25.5939 20.3393 24.4642 21.3391 24.1712 22.958C24.1229 23.2329 24.0957 23.5229 24.0957 23.831C24.0957 24.1391 24.1199 24.423 24.1682 24.6918C24.4582 26.3078 25.5878 27.3106 27.1796 27.5764C27.4605 27.6247 27.7566 27.6489 28.0646 27.6489C28.3727 27.6489 28.6446 27.6277 28.9134 27.5824C30.5022 27.3227 31.6349 26.3199 31.9248 24.6918H31.9279Z",
        fill: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M26.2701 20.2856L28.6925 23.252L28.8406 23.4336L26.5508 27.3679L26.5358 27.3653L26.448 27.3503C25.2457 26.9308 24.4115 26.0066 24.1682 24.651C24.1199 24.3822 24.0957 24.0982 24.0957 23.7901C24.0957 23.482 24.1229 23.1921 24.1712 22.9172C24.4045 21.6282 25.1681 20.7317 26.2701 20.2856Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M30.7008 22.6769L27.4765 25.7641L25.8105 24.1249L26.5298 23.4568L27.4888 24.3986L29.9939 22L30.7039 22.6798L30.7008 22.6769Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$e6598341d5f08715 = function ITSupport2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M10.0205 14.166V31.416L15.0163 27.1327H30.0122V14.166H10.0205Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M18.8997 14.6787C18.8997 13.4412 19.8872 12.4495 21.1081 12.4495C22.3289 12.4495 23.3164 13.437 23.3164 14.6787C23.3164 15.3079 23.1664 15.5954 23.0289 15.7787C22.8664 15.9912 22.6622 16.1412 22.3039 16.4037C22.2456 16.4495 22.1789 16.4954 22.1081 16.5454C21.6622 16.8745 21.0956 17.3245 20.6706 18.0704C20.2414 18.8204 20.0039 19.762 20.0039 21.0079H22.2122C22.2122 20.0412 22.3914 19.5037 22.5831 19.1745C22.7747 18.837 23.0372 18.6079 23.4206 18.3245C23.4664 18.2912 23.5164 18.2537 23.5706 18.2162C23.9164 17.9662 24.4081 17.612 24.7789 17.1245C25.2581 16.4995 25.5247 15.7162 25.5247 14.6787C25.5247 12.237 23.5664 10.2412 21.1081 10.2412C18.6497 10.2412 16.6914 12.237 16.6914 14.6787V15.7829H18.8997V14.6787Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.1087 22.6709C20.3462 22.6709 19.7295 23.2876 19.7295 24.0501C19.7295 24.8126 20.3462 25.4292 21.1087 25.4292C21.8712 25.4292 22.4878 24.8126 22.4878 24.0501C22.4878 23.2876 21.8712 22.6709 21.1087 22.6709Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M16.7167 14.166H18.9583C18.9167 14.3285 18.8958 14.5035 18.8958 14.6785V15.7827H16.6875V14.6785C16.6875 14.5077 16.6958 14.3368 16.7167 14.166Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M22.4871 24.0491C22.4871 24.8116 21.8704 25.4324 21.1079 25.4324C20.3454 25.4324 19.7246 24.8116 19.7246 24.0491C19.7246 23.2866 20.3454 22.6699 21.1079 22.6699C21.8704 22.6699 22.4871 23.2866 22.4871 24.0491Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.5247 14.6785C25.5247 15.7202 25.2581 16.4993 24.7789 17.1243C24.4081 17.6118 23.9164 17.966 23.5706 18.216C23.5164 18.2577 23.4664 18.291 23.4206 18.3243C23.0372 18.6118 22.7747 18.841 22.5831 19.1785C22.3914 19.5118 22.2122 20.0493 22.2122 21.0118H20.0039C20.0039 19.766 20.2372 18.8243 20.6664 18.0785C21.0956 17.3327 21.6622 16.8827 22.1039 16.5493C22.1747 16.4993 22.2414 16.4535 22.2997 16.4077C22.6622 16.141 22.8622 15.9952 23.0247 15.7827C23.1664 15.5952 23.3164 15.3077 23.3164 14.6785C23.3164 14.5035 23.2956 14.3285 23.2539 14.166H25.4956C25.5164 14.3368 25.5247 14.5077 25.5247 14.6785Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$10c57db1e3cf8326 = function HumanResourcesGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M28.2374 11.7456H11.7041V33.3456H28.2374V11.7456Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M16.6831 28.9165C16.6831 27.0124 18.2248 25.4707 20.1289 25.4707C22.0331 25.4707 23.5748 27.0124 23.5748 28.9165V33.3457H16.6831V28.9165Z",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M23.0831 21.0416C23.0831 22.6707 21.7623 23.9957 20.129 23.9957C18.4956 23.9957 17.1748 22.6749 17.1748 21.0416C17.1748 19.4082 18.4956 18.0874 20.129 18.0874C21.7623 18.0874 23.0831 19.4082 23.0831 21.0416Z",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.908 9.95391V15.0831H14.0288V9.95391H17.5205C17.5205 8.59974 18.6163 7.50391 19.9705 7.50391C21.3246 7.50391 22.4163 8.59974 22.4163 9.95391H25.908Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.908 11.7456H14.0288V15.0831H25.908V11.7456Z",
        fill: "#164B35"
    }));
};
var $e8bb3a80267c3ab3$export$925c822e766a0944 = function CustomerSuccess2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M23.2917 24.4C22.6583 28.5625 18.7708 31.425 14.6083 30.7917C10.4458 30.1583 7.58333 26.2708 8.21667 22.1083C8.85 17.9458 12.7375 15.0833 16.9 15.7167C21.0625 16.35 23.925 20.2375 23.2917 24.4ZM14.9208 21.475C15.0125 20.8792 14.6042 20.325 14.0083 20.2333C13.4125 20.1417 12.8583 20.55 12.7667 21.1458C12.675 21.7417 13.0833 22.2958 13.6792 22.3875C14.275 22.4792 14.8292 22.0708 14.9208 21.475ZM19.2292 22.1292C19.3208 21.5333 18.9125 20.9792 18.3167 20.8875C17.7208 20.7958 17.1667 21.2042 17.075 21.8C16.9833 22.3958 17.3917 22.95 17.9875 23.0417C18.5833 23.1333 19.1375 22.725 19.2292 22.1292ZM13.3083 25.05L12.825 24.3917L11.5083 25.3583L11.9917 26.0167C13.5208 28.0917 16.4417 28.5375 18.5208 27.0083L19.1792 26.525L18.2125 25.2083L17.5542 25.6917C16.2042 26.6833 14.3042 26.3958 13.3125 25.0458L13.3083 25.05Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M22.8419 9.2748C18.7044 10.0498 15.9752 14.0331 16.7502 18.1748C17.5252 22.3123 21.5085 25.0415 25.646 24.2665C29.7835 23.4915 32.5169 19.5081 31.7419 15.3706C30.9669 11.2331 26.9794 8.50396 22.8419 9.2748ZM25.8835 13.6915C26.4752 13.579 27.0419 13.9706 27.1544 14.5623C27.2669 15.154 26.8752 15.7206 26.2835 15.8331C25.6919 15.9456 25.1252 15.554 25.0127 14.9623C24.9002 14.3706 25.2919 13.804 25.8835 13.6915ZM21.6002 14.4915C22.1919 14.379 22.7585 14.7706 22.871 15.3623C22.9835 15.954 22.5919 16.5206 22.0002 16.6331C21.4085 16.7456 20.8419 16.354 20.7294 15.7623C20.6169 15.1706 21.0085 14.604 21.6002 14.4915ZM25.2335 22.054C23.1585 22.4415 21.1669 21.079 20.7794 19.0123L28.2752 17.6081C28.6627 19.679 27.296 21.6665 25.2294 22.054H25.2335Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z",
        fill: "#09326C"
    }));
};
var $e8bb3a80267c3ab3$export$c0094cf6ece486f3 = function Legal2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.5832 13.6997H8.4165V16.9455H31.5832V13.6997Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.5832 26.6914H8.4165V29.9372H31.5832V26.6914Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M13.9248 29.9375V16.9458H10.1331V29.9375H13.9248Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.8955 29.9375V16.9458H18.1038V29.9375H21.8955Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M29.8291 29.9375V16.9458H26.0374V29.9375H29.8291Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M19.9998 8.4165L8.4165 16.9457H31.5832L19.9998 8.4165Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.5832 16.9455H8.4165L12.8248 13.6997H27.1748L31.5832 16.9455Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z",
        fill: "#09326C"
    }));
};
var $e8bb3a80267c3ab3$export$526fd3870ee3978 = function Finance2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.9459 22.2458V19.8291C31.9459 19.2041 31.3793 18.6958 30.6751 18.6958H16.4334C15.7293 18.6958 15.1626 19.2 15.1626 19.8291V22.2458H31.9459Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.9459 23.8291H15.1626V28.8041C15.1626 29.425 15.7293 29.9375 16.4334 29.9375H30.6751C31.3793 29.9375 31.9459 29.4291 31.9459 28.8041V23.8291Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.1002 13.4919V11.0752C25.1002 10.4502 24.5336 9.94189 23.8294 9.94189H9.58773C8.88356 9.94189 8.31689 10.4461 8.31689 11.0752V13.4919H25.1002Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.1002 15.0752H8.31689V20.0502C8.31689 20.6711 8.88356 21.1836 9.58773 21.1836H23.8294C24.5336 21.1836 25.1002 20.6752 25.1002 20.0502V15.0752Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$6361c44213db83a2 = function Sales2Glyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M30.1166 33.2749H9.8833V6.8374H20.1125L30.1166 16.6916V33.2749Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M20.1084 6.8374V16.6624H30.0876L20.1084 6.8374Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.6917 19.9043H20.1084V22.696H25.6917V19.9043Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M16.3874 23.1625C17.416 23.1625 18.2499 22.3286 18.2499 21.3C18.2499 20.2714 17.416 19.4375 16.3874 19.4375C15.3588 19.4375 14.5249 20.2714 14.5249 21.3C14.5249 22.3286 15.3588 23.1625 16.3874 23.1625Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.6917 26.9458H20.1084V29.7375H25.6917V26.9458Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M16.3874 30.204C17.416 30.204 18.2499 29.3701 18.2499 28.3415C18.2499 27.3129 17.416 26.479 16.3874 26.479C15.3588 26.479 14.5249 27.3129 14.5249 28.3415C14.5249 29.3701 15.3588 30.204 16.3874 30.204Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$b5a9699d43e96f3e = function DataScienceGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M9.1792 9.18311V26.7998H26.7959V9.18311H9.1792ZM16.7292 12.9664H23.0209V14.8539H16.7292V12.9664ZM16.7292 17.0456H23.0209V18.9331H16.7292V17.0456ZM13.5875 12.6414C14.2792 12.6414 14.8459 13.2081 14.8459 13.8998C14.8459 14.5914 14.2792 15.1581 13.5875 15.1581C12.8959 15.1581 12.3292 14.5956 12.3292 13.8998C12.3292 13.2039 12.8917 12.6414 13.5875 12.6414ZM13.5875 16.7331C14.2792 16.7331 14.8459 17.2956 14.8459 17.9914C14.8459 18.6873 14.2792 19.2498 13.5875 19.2498C12.8959 19.2498 12.3292 18.6873 12.3292 17.9914C12.3292 17.2956 12.8917 16.7331 13.5875 16.7331Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M29.1873 20.0498V22.9706H16.729V28.9081H29.1873V32.4165L35.3665 26.229L29.1873 20.0498Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M16.729 22.9707V26.7999H26.7957V22.9707H16.729Z",
        fill: "#09326C"
    }));
};
var $e8bb3a80267c3ab3$export$9fe16602583dd125 = function OtherGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M18.2215 11.0342C12.574 11.0342 8 15.6127 8 21.2557C8 25.5094 10.5982 29.1586 14.2971 30.6968V28.2294C14.2971 26.0597 16.0563 24.305 18.2215 24.305C20.3867 24.305 22.1414 26.0642 22.1414 28.2294V30.6968C25.8403 29.1631 28.443 25.5139 28.443 21.2557C28.443 15.6081 23.8645 11.0342 18.2215 11.0342ZM18.2215 23.1998C16.3631 23.1998 14.8564 21.6932 14.8564 19.8348C14.8564 17.9763 16.3585 16.4697 18.2215 16.4697C20.0845 16.4697 21.5821 17.9718 21.5821 19.8348C21.5821 21.6977 20.08 23.1998 18.2215 23.1998Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M24.5408 12.9421L20.9321 14.7465L24.5408 16.5508L26.3451 20.1595L28.1494 16.5508L31.7581 14.7465L28.1494 12.9421L26.3451 9.3335L24.5408 12.9421Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M27.7034 17.4438L26.3456 20.1593L24.5413 16.5507L20.9326 14.7464L24.3202 13.0503C25.8178 14.169 26.9997 15.6846 27.7034 17.4438Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M24.3202 13.0503L20.9326 14.7464L24.5413 16.5507L26.3456 20.1593L27.7034 17.4438C26.9997 15.6846 25.8178 14.169 24.3202 13.0503Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$6c259bad890ba857 = function SoftwareDevleopmentHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M47.4626 15.5811H12.5376V38.4498H47.4626V15.5811Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M39.3811 41.581V45.4685H20.6187V41.581H26.8687V34.606H33.1311V41.581H39.3811Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M33.1312 34.606H26.8687V38.456H33.1312V34.606Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M30.0002 32.4438C32.9963 32.4438 35.4252 30.0149 35.4252 27.0188C35.4252 24.0226 32.9963 21.5938 30.0002 21.5938C27.0041 21.5938 24.5752 24.0226 24.5752 27.0188C24.5752 30.0149 27.0041 32.4438 30.0002 32.4438Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$50a598674e46acd6 = function ProductManagementHeaderGylph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.0125 14.0562H26.8438L28.675 18.9499L33.8313 18.0937L36.7438 23.1437L33.425 27.1812L36.7438 31.2124L33.8313 36.2624L28.6812 35.4062L26.85 40.2999H21.0188L19.1875 35.4062L14.0375 36.2624L11.125 31.2124L14.4437 27.1812L11.125 23.1499L14.0375 18.0999L19.1938 18.9562L21.025 14.0624L21.0125 14.0562ZM23.925 32.0937C26.6437 32.0937 28.8438 29.8937 28.8438 27.1749C28.8438 24.4562 26.6437 22.2562 23.925 22.2562C21.2063 22.2562 19.0063 24.4562 19.0063 27.1749C19.0063 29.8937 21.2063 32.0937 23.925 32.0937Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M37.4435 25.6499H42.256L43.7685 29.6874L48.0247 28.9812L50.431 33.1499L47.6872 36.4812L50.4247 39.8124L48.0185 43.9812L43.7622 43.2749L42.2497 47.3124H37.4372L35.9247 43.2749L31.6685 43.9812L29.2622 39.8124L31.9997 36.4812L29.2622 33.1499L31.6685 28.9812L35.9247 29.6874L37.4372 25.6499H37.4435ZM39.8497 40.5437C42.0935 40.5437 43.9122 38.7249 43.9122 36.4812C43.9122 34.2374 42.0935 32.4187 39.8497 32.4187C37.606 32.4187 35.7872 34.2374 35.7872 36.4812C35.7872 38.7249 37.606 40.5437 39.8497 40.5437Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.4248 27.175L36.7436 23.1437L33.8311 18.0938L28.6748 18.95L26.8436 14.0625H21.0123L19.1748 18.95L14.0248 18.0938L11.1123 23.1437L14.4311 27.175L11.1123 31.2125L14.0248 36.2625L19.1748 35.4L21.0123 40.2938H26.8436L28.6748 35.4L31.5123 35.875L33.8311 36.2625L36.7436 31.2125L35.4186 29.6L33.4248 27.175ZM23.9248 32.0938C21.2123 32.0938 19.0061 29.8937 19.0061 27.175C19.0061 24.4563 21.2123 22.2563 23.9248 22.2563C26.6373 22.2563 28.8436 24.4625 28.8436 27.175C28.8436 29.8875 26.6436 32.0938 23.9248 32.0938Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.4186 29.5997L31.6748 28.981L29.2686 33.1497L31.5123 35.8747L33.8311 36.2622L36.7436 31.2122L35.4186 29.5997Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$bc46f4026380149b = function MarketingHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M44.5936 16.3623L30.9561 21.8186V36.3686L44.5936 41.8248V16.3623Z",
        fill: "#1868DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M34.45 22.7246V35.4371H27.3187V43.6371H21.8625V35.4371H16.4062V22.7246H34.45Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M34.4498 22.7246H30.9561V35.4309H34.4498V22.7246Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$2d48c6a000b33e3 = function DesignHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M38.1437 31.6438C38.2437 31.0875 38.2938 30.4875 38.2938 29.8625C38.2938 29.2375 38.2438 28.625 38.1375 28.0563C37.5313 24.6875 35.1938 22.6125 31.9062 22.075C31.3438 21.9813 30.7563 21.9375 30.15 21.9375C29.5438 21.9375 28.9 21.9875 28.3188 22.0875C25.0375 22.6375 22.7 24.7063 22.0938 28.0563C21.9938 28.625 21.9375 29.225 21.9375 29.8625C21.9375 30.5 21.9875 31.0875 22.0875 31.6438C22.6875 34.9875 25.025 37.0625 28.3188 37.6125C28.9 37.7125 29.5125 37.7625 30.15 37.7625C30.7875 37.7625 31.35 37.7188 31.9062 37.625C35.1938 37.0875 37.5375 35.0125 38.1375 31.6438H38.1437Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M11.0562 28.9752L20.8062 12.2627L30.5562 28.9752H11.0562Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M26.7688 22.4878C24.3063 23.3503 22.5937 25.2565 22.0937 28.0565C22.0375 28.3565 22 28.6565 21.9688 28.9753H30.55L26.7688 22.4878Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M44.8748 31.3252H31.1748V45.0252H44.8748V31.3252Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.1748 31.3315V37.719C31.4248 37.694 31.6686 37.6628 31.9123 37.6253C35.1998 37.094 37.5373 35.0128 38.1436 31.644C38.1623 31.544 38.1811 31.4378 38.1936 31.3315H31.1748Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$d2da7b6954e156a3 = function ProjectManagementGylph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M49.9125 27.1812H19.4688V42.0562H49.9125V27.1812Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M40.45 17.9438H10.0062V32.8188H40.45V17.9438Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M40.45 27.1812H19.4688V32.8187H40.45V27.1812Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.0249 22.9937L15.4687 29.5499L12.0812 26.0687L13.5437 24.6499L15.4937 26.6499L20.5874 21.5562L22.0312 22.9999L22.0249 22.9937Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.0187 32.5562L41.4625 39.1124L38.075 35.6312L39.5375 34.2124L41.4875 36.2124L46.5812 31.1187L48.025 32.5624L48.0187 32.5562Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$f6faf0bdc0af7562 = function OperationsHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.7175 15.0458L31.5474 15.0729L33.6696 20.8132L39.7128 19.8342L43.1007 25.7626L39.1948 30.4761L43.0633 35.2131L39.6286 41.1144L33.6006 40.0877L31.433 45.811L24.6031 45.784L22.481 40.0437L16.445 41.0227L13.0572 35.0943L16.963 30.3881L13.0946 25.6511L16.5292 19.7498L22.5646 20.7766L24.7321 15.0532L24.7175 15.0458ZM28.0451 36.1858C31.2295 36.1985 33.8165 33.6319 33.8291 30.4475C33.8417 27.2632 31.2751 24.6762 28.0908 24.6636C24.9064 24.651 22.3195 27.2176 22.3068 30.4019C22.2942 33.5863 24.8608 36.1732 28.0451 36.1858Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.1945 30.4688L43.1003 25.7626L39.7124 19.8343L33.6691 20.8133L31.5469 15.0803L24.7171 15.0532L22.5422 20.7692L16.5142 19.7424L13.0795 25.6438L16.948 30.3808L13.0421 35.0943L16.43 41.0227L22.466 40.0363L24.5954 45.7767L31.4253 45.8037L33.5929 40.0804L36.9141 40.6499L39.6282 41.1145L43.0628 35.2132L41.5184 33.3184L39.1945 30.4688ZM28.0447 36.1859C24.8677 36.1733 22.2938 33.5863 22.3064 30.402C22.319 27.2176 24.9133 24.6511 28.0904 24.6637C31.2674 24.6763 33.8412 27.2706 33.8287 30.4476C33.8161 33.6246 31.2291 36.1985 28.0447 36.1859Z",
        fill: "#FFA900"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        style: {
            mixBlendMode: 'multiply'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M47.8907 37.0382C47.9632 36.635 47.9995 36.2 47.9995 35.7469C47.9995 35.2939 47.9632 34.8499 47.8862 34.4376C47.4467 31.9955 45.7522 30.4913 43.3691 30.1016C42.9613 30.0337 42.5354 30.002 42.0959 30.002C41.6564 30.002 41.1898 30.0382 40.7684 30.1107C38.3898 30.5094 36.6953 32.0091 36.2558 34.4376C36.1833 34.8499 36.1425 35.2848 36.1425 35.7469C36.1425 36.2091 36.1787 36.635 36.2512 37.0382C36.6862 39.4622 38.3807 40.9664 40.7684 41.3651C41.1898 41.4376 41.6338 41.4738 42.0959 41.4738C42.558 41.4738 42.9658 41.4421 43.3691 41.3741C45.7522 40.9845 47.4513 39.4803 47.8862 37.0382H47.8907Z",
        fill: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.4038 30.4282L43.0336 34.8731L43.2603 35.1511L39.8256 41.0523L39.7036 41.0316L39.6768 41.027C37.8703 40.3987 36.6167 39.0117 36.2514 36.976C36.1789 36.5728 36.1426 36.1469 36.1426 35.6848C36.1426 35.2226 36.1834 34.7877 36.2559 34.3754C36.6058 32.442 37.7511 31.0973 39.4038 30.4282Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.0498 34.0153L41.2133 38.6462L38.7144 36.1873L39.7932 35.1852L41.2317 36.5978L44.9894 33L46.0544 34.0198L46.0498 34.0153Z",
        fill: "white"
    }));
};
var $e8bb3a80267c3ab3$export$edf22519467780de = function ITSupportHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0312 21.25V47.125L22.525 40.7H45.0187V21.25H15.0312Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M28.35 22.0186C28.35 20.1623 29.8312 18.6748 31.6625 18.6748C33.4937 18.6748 34.975 20.1561 34.975 22.0186C34.975 22.9623 34.75 23.3936 34.5437 23.6686C34.3 23.9873 33.9937 24.2123 33.4562 24.6061C33.3687 24.6748 33.2687 24.7436 33.1625 24.8186C32.4937 25.3123 31.6437 25.9873 31.0062 27.1061C30.3625 28.2311 30.0062 29.6436 30.0062 31.5123H33.3187C33.3187 30.0623 33.5875 29.2561 33.875 28.7623C34.1625 28.2561 34.5562 27.9123 35.1312 27.4873C35.2 27.4373 35.275 27.3811 35.3562 27.3248C35.875 26.9498 36.6125 26.4186 37.1687 25.6873C37.8875 24.7498 38.2875 23.5748 38.2875 22.0186C38.2875 18.3561 35.35 15.3623 31.6625 15.3623C27.975 15.3623 25.0375 18.3561 25.0375 22.0186V23.6748H28.35V22.0186Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M31.6625 34.0059C30.5188 34.0059 29.5938 34.9309 29.5938 36.0746C29.5938 37.2184 30.5188 38.1434 31.6625 38.1434C32.8063 38.1434 33.7313 37.2184 33.7313 36.0746C33.7313 34.9309 32.8063 34.0059 31.6625 34.0059Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.075 21.25H28.4375C28.375 21.4937 28.3437 21.7562 28.3437 22.0187V23.675H25.0312V22.0187C25.0312 21.7625 25.0437 21.5062 25.075 21.25Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.7313 36.0751C33.7313 37.2188 32.8063 38.1501 31.6625 38.1501C30.5188 38.1501 29.5875 37.2188 29.5875 36.0751C29.5875 34.9313 30.5188 34.0063 31.6625 34.0063C32.8063 34.0063 33.7313 34.9313 33.7313 36.0751Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.2875 22.0187C38.2875 23.5812 37.8875 24.75 37.1687 25.6875C36.6125 26.4187 35.875 26.95 35.3562 27.325C35.275 27.3875 35.2 27.4375 35.1312 27.4875C34.5562 27.9187 34.1625 28.2625 33.875 28.7687C33.5875 29.2687 33.3187 30.075 33.3187 31.5188H30.0062C30.0062 29.65 30.3562 28.2375 31 27.1187C31.6437 26 32.4937 25.325 33.1562 24.825C33.2625 24.75 33.3625 24.6813 33.45 24.6125C33.9937 24.2125 34.2937 23.9938 34.5375 23.675C34.75 23.3938 34.975 22.9625 34.975 22.0187C34.975 21.7562 34.9437 21.4937 34.8812 21.25H38.2437C38.275 21.5062 38.2875 21.7625 38.2875 22.0187Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$8c7409f1554738f7 = function HumanResourcesHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#clip0_1_5039)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M42.8564 17.6187H18.0564V50.0187H42.8564V17.6187Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M25.5249 43.3753C25.5249 40.519 27.8374 38.2065 30.6937 38.2065C33.5499 38.2065 35.8624 40.519 35.8624 43.3753V50.019H25.5249V43.3753Z",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M35.125 31.5626C35.125 34.0063 33.1437 35.9938 30.6937 35.9938C28.2437 35.9938 26.2625 34.0126 26.2625 31.5626C26.2625 29.1126 28.2437 27.1313 30.6937 27.1313C33.1437 27.1313 35.125 29.1126 35.125 31.5626Z",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M39.3624 14.9313V22.6251H21.5437V14.9313H26.7812C26.7812 12.9001 28.425 11.2563 30.4562 11.2563C32.4875 11.2563 34.1249 12.9001 34.1249 14.9313H39.3624Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M39.3624 17.6187H21.5437V22.6249H39.3624V17.6187Z",
        fill: "#164B35"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "clip0_1_5039"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white"
    }))));
};
var $e8bb3a80267c3ab3$export$b20b85b1cb35523d = function CustomerServiceHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#clip0_1_4707)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.9375 36.6C33.9875 42.8438 28.1563 47.1375 21.9125 46.1875C15.6688 45.2375 11.375 39.4063 12.325 33.1625C13.275 26.9188 19.1063 22.625 25.35 23.575C31.5938 24.525 35.8875 30.3563 34.9375 36.6ZM22.3813 32.2125C22.5188 31.3188 21.9062 30.4875 21.0125 30.35C20.1188 30.2125 19.2875 30.825 19.15 31.7188C19.0125 32.6125 19.625 33.4438 20.5188 33.5813C21.4125 33.7188 22.2438 33.1063 22.3813 32.2125ZM28.8438 33.1938C28.9813 32.3 28.3688 31.4688 27.475 31.3313C26.5813 31.1938 25.75 31.8063 25.6125 32.7C25.475 33.5938 26.0875 34.425 26.9813 34.5625C27.875 34.7 28.7063 34.0875 28.8438 33.1938ZM19.9625 37.575L19.2375 36.5875L17.2625 38.0375L17.9875 39.025C20.2813 42.1375 24.6625 42.8063 27.7813 40.5125L28.7688 39.7875L27.3188 37.8125L26.3313 38.5375C24.3063 40.025 21.4563 39.5938 19.9688 37.5688L19.9625 37.575Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.2625 13.9127C28.0563 15.0752 23.9625 21.0502 25.125 27.2627C26.2875 33.4689 32.2625 37.5627 38.4688 36.4002C44.675 35.2377 48.775 29.2627 47.6125 23.0564C46.45 16.8502 40.4688 12.7564 34.2625 13.9127ZM38.825 20.5377C39.7125 20.3689 40.5625 20.9564 40.7313 21.8439C40.9 22.7314 40.3125 23.5814 39.425 23.7502C38.5375 23.9189 37.6875 23.3314 37.5188 22.4439C37.35 21.5564 37.9375 20.7064 38.825 20.5377ZM32.4 21.7377C33.2875 21.5689 34.1375 22.1564 34.3063 23.0439C34.475 23.9314 33.8875 24.7814 33 24.9502C32.1125 25.1189 31.2625 24.5314 31.0938 23.6439C30.925 22.7564 31.5125 21.9064 32.4 21.7377ZM37.85 33.0814C34.7375 33.6627 31.75 31.6189 31.1688 28.5189L42.4125 26.4127C42.9938 29.5189 40.9438 32.5002 37.8438 33.0814H37.85Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z",
        fill: "#09326C"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "clip0_1_4707"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white"
    }))));
};
var $e8bb3a80267c3ab3$export$ab9f12136609e96a = function LegalHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#clip0_1_5503)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M48.375 20.5498H13.625V25.4186H48.375V20.5498Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M48.375 40.0376H13.625V44.9063H48.375V40.0376Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.8877 44.9064V25.4189H16.2002V44.9064H21.8877Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M33.8438 44.9064V25.4189H28.1562V44.9064H33.8438Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M45.7437 44.9064V25.4189H40.0562V44.9064H45.7437Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31 12.625L13.625 25.4187H48.375L31 12.625Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.375 25.4186H13.625L20.2375 20.5498H41.7625L48.375 25.4186Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z",
        fill: "#09326C"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "clip0_1_5503"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white",
        transform: "translate(0.5)"
    }))));
};
var $e8bb3a80267c3ab3$export$8aaa0b75bd31bddc = function FinanceHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#clip0_1_6742)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M48.9187 33.369V29.7439C48.9187 28.8064 48.0687 28.0439 47.0124 28.0439H25.6499C24.5937 28.0439 23.7437 28.8002 23.7437 29.7439V33.369H48.9187Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M48.9187 35.744H23.7437V43.2064C23.7437 44.1377 24.5937 44.9064 25.6499 44.9064H47.0124C48.0687 44.9064 48.9187 44.1439 48.9187 43.2064V35.744Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M38.6501 20.2376V16.6126C38.6501 15.6751 37.8001 14.9126 36.7438 14.9126H15.3813C14.3251 14.9126 13.4751 15.6688 13.4751 16.6126V20.2376H38.6501Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M38.6501 22.6126H13.4751V30.0751C13.4751 31.0063 14.3251 31.7751 15.3813 31.7751H36.7438C37.8001 31.7751 38.6501 31.0126 38.6501 30.0751V22.6126Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z",
        fill: "#AE2A19"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "clip0_1_6742"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white",
        transform: "translate(0.5)"
    }))));
};
var $e8bb3a80267c3ab3$export$b61109ed43b719cd = function SalesHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#clip0_1_5805)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M45.1752 49.9126H14.8252V10.2563H30.1689L45.1752 25.0376V49.9126Z",
        fill: "#FCA700",
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M30.1631 10.2563V24.9938H45.1318L30.1631 10.2563Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M38.5381 29.8564H30.1631V34.0439H38.5381V29.8564Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M24.5818 34.7438C26.1248 34.7438 27.3756 33.4929 27.3756 31.95C27.3756 30.4071 26.1248 29.1562 24.5818 29.1562C23.0389 29.1562 21.7881 30.4071 21.7881 31.95C21.7881 33.4929 23.0389 34.7438 24.5818 34.7438Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M38.5381 40.4189H30.1631V44.6064H38.5381V40.4189Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M24.5818 45.3062C26.1248 45.3062 27.3756 44.0554 27.3756 42.5125C27.3756 40.9696 26.1248 39.7188 24.5818 39.7188C23.0389 39.7188 21.7881 40.9696 21.7881 42.5125C21.7881 44.0554 23.0389 45.3062 24.5818 45.3062Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "clip0_1_5805"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white"
    }))));
};
var $e8bb3a80267c3ab3$export$89158573528fcad1 = function DataScienceHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("g", {
        clipPath: "url(#clip0_1_6101)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2686 13.7749V40.1999H40.6936V13.7749H14.2686ZM25.5936 19.4499H35.0311V22.2812H25.5936V19.4499ZM25.5936 25.5687H35.0311V28.3999H25.5936V25.5687ZM20.8811 18.9624C21.9186 18.9624 22.7686 19.8124 22.7686 20.8499C22.7686 21.8874 21.9186 22.7374 20.8811 22.7374C19.8436 22.7374 18.9936 21.8937 18.9936 20.8499C18.9936 19.8062 19.8373 18.9624 20.8811 18.9624ZM20.8811 25.0999C21.9186 25.0999 22.7686 25.9437 22.7686 26.9874C22.7686 28.0312 21.9186 28.8749 20.8811 28.8749C19.8436 28.8749 18.9936 28.0312 18.9936 26.9874C18.9936 25.9437 19.8373 25.0999 20.8811 25.0999Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M44.2812 30.0747V34.456H25.5938V43.3622H44.2812V48.6247L53.55 39.3435L44.2812 30.0747Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5938 34.4561V40.1998H40.6937V34.4561H25.5938Z",
        fill: "#09326C"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("clipPath", {
        id: "clip0_1_6101"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("rect", {
        width: "60",
        height: "60",
        fill: "white"
    }))));
};
var $e8bb3a80267c3ab3$export$2957996a5f53a712 = function OtherHeaderGlyph() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M27.8323 16.5508C19.3609 16.5508 12.5 23.4185 12.5 31.883C12.5 38.2636 16.3973 43.7375 21.9456 46.0447V42.3436C21.9456 39.0891 24.5845 36.457 27.8323 36.457C31.08 36.457 33.7121 39.0958 33.7121 42.3436V46.0447C39.2604 43.7442 43.1645 38.2704 43.1645 31.883C43.1645 23.4117 36.2968 16.5508 27.8323 16.5508ZM27.8323 34.7993C25.0446 34.7993 22.7847 32.5394 22.7847 29.7517C22.7847 26.964 25.0378 24.7041 27.8323 24.7041C30.6267 24.7041 32.8731 26.9572 32.8731 29.7517C32.8731 32.5461 30.6199 34.7993 27.8323 34.7993Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M37.3114 19.413L31.8984 22.1195L37.3114 24.826L40.0179 30.2389L42.7244 24.826L48.1374 22.1195L42.7244 19.413L40.0179 14L37.3114 19.413Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M42.0555 26.1655L40.0189 30.2388L37.3124 24.8258L31.8994 22.1193L36.9808 19.5752C39.2272 21.2532 41 23.5267 42.0555 26.1655Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("path", {
        d: "M36.9808 19.5752L31.8994 22.1193L37.3124 24.8258L40.0189 30.2388L42.0555 26.1655C41 23.5267 39.2272 21.2532 36.9808 19.5752Z",
        fill: "#AE2A19"
    }));
};
var $e8bb3a80267c3ab3$export$cb277cd1c06981d4 = function ITSupportIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$var$ITSupportGlyph,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$966748bc0ae8d9a2 = function DesignIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$var$DesignGlyph,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$ddb421af37c7fad5 = function MarketingIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$a8475ed0ad467766,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$1c5b0383ec045924 = function SoftwareDevelopmentIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$var$SoftwareDevelopmentGlyph,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$711ab9ba848867b8 = function OperationsIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$7a5074cf88127a64,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$162047bea11a6282 = function PeopleAndOtherIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$5a330511b92aac24,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$982ea2d26785cb86 = function SalesIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$2a1d70df8da1fa8a,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$76f950842b166c42 = function CustomerServiceIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$c3c91f9d6f32ce98,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$a8119f2277c08f44 = function FinanceIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$a9941a16640f105a,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$ae563fd41f5cca8a = function HrIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$b81d861c2dc0475e,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$e809d817369bee46 = function LegalIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$f2de52c1920eba82,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$3f7b13292eed3fe1 = function SoftwareDevelopmentIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$816a17ab71a9c447,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$e142eb117e369c8f = function ProductManagementIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$b6c5d967ad9baf32,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$a53784039f0a17d0 = function MarketingIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$89a8de63b42b4bf7,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$d8b6fe79c3f35976 = function DesignIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$27ec4a87867305fc,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$86f8858d201b0f9e = function ProjectManagementIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$a9d1d41ede76da88,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$2037b55ec364c78 = function OperationsIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$a10f1df78def0898,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$ddadca1ef61d72f4 = function ITSupportIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$e6598341d5f08715,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$294977ef66033c05 = function HumanResourcesIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$10c57db1e3cf8326,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$f491740eeb057ed5 = function CustomerServiceIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$925c822e766a0944,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$8ab8d8da70776293 = function LegalIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$c0094cf6ece486f3,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$cf4b8a9193cf22e1 = function FinanceIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$526fd3870ee3978,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$fd9729397ff432bf = function SalesIcon2() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$6361c44213db83a2,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$a2e400cb60027285 = function DataScienceIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$b5a9699d43e96f3e,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$bace2d8ac2cf2caa = function OtherIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$9fe16602583dd125,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$e11bc36dd8a99125 = function SoftwareDevelopmentHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$6c259bad890ba857,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$72976b44f07f811b = function ProductManagementHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$50a598674e46acd6,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$bfad4d4e8f73e77e = function MarketingHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$bc46f4026380149b,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$d3f781ec209b4fd7 = function DesignHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$2d48c6a000b33e3,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$bababd42ef961024 = function ProjectManagementHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$d2da7b6954e156a3,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$6efd0fa33b4aa14d = function OperationsHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$f6faf0bdc0af7562,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$6c12f9ab3896c60b = function ITSupportHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$edf22519467780de,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$6de851e46e3b87af = function HumanResourcesHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$8c7409f1554738f7,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$ab663870e0e1a3cd = function CustomerServiceHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$b20b85b1cb35523d,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$3fb457a290d0178f = function LegalHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$ab9f12136609e96a,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$1b11a71dd9d8f914 = function FinanceHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$8aaa0b75bd31bddc,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$f2bd611053c3be8a = function SalesHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$b61109ed43b719cd,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$f7c6a6f312b0247 = function DataScienceHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$89158573528fcad1,
        label: ""
    });
};
var $e8bb3a80267c3ab3$export$f8101b6de63ddffb = function OtherHeaderIcon() {
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $fAV5E.default), {
        glyph: $e8bb3a80267c3ab3$export$2957996a5f53a712,
        label: ""
    });
};

});
parcelRegister("fAV5E", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b5a680b4f70944b8$export$2e2bcd8739ae039; });
/* icon.tsx generated by @compiled/babel-plugin v0.38.1 */ 
var $2xu97 = parcelRequire("2xu97");

var $cnzEg = parcelRequire("cnzEg");

var $1oC0p = parcelRequire("1oC0p");

var $6wmhB = parcelRequire("6wmhB");
function $b5a680b4f70944b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5a680b4f70944b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5a680b4f70944b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $cnzEg.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5a680b4f70944b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $b5a680b4f70944b8$var$iconStyles = null;
var $b5a680b4f70944b8$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $b5a680b4f70944b8$var$baseHcmStyles = null;
var $b5a680b4f70944b8$var$primaryEqualsSecondaryHcmStyles = null;
var $b5a680b4f70944b8$var$secondaryTransparentHcmStyles = null;
var $b5a680b4f70944b8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $1oC0p.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $1oC0p.createElement("span", (0, $2xu97.default)({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $b5a680b4f70944b8$var$_objectSpread($b5a680b4f70944b8$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $6wmhB.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $b5a680b4f70944b8$var$sizeStyles[size]
        ])
    }));
});
var $b5a680b4f70944b8$export$2e2bcd8739ae039 = $b5a680b4f70944b8$export$f04a61298a47a40f;

});
parcelRegister("2xu97", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1d960c35ebcd8272$export$2e2bcd8739ae039; });
function $1d960c35ebcd8272$export$2e2bcd8739ae039() {
    return $1d960c35ebcd8272$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d960c35ebcd8272$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6wmhB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4bf704289be70483$export$2e2bcd8739ae039; });
const $4bf704289be70483$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $4bf704289be70483$var$ATOMIC_GROUP_LENGTH = 5;
function $4bf704289be70483$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $4bf704289be70483$var$UNDERSCORE_UNICODE ? $4bf704289be70483$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});




parcelRegister("hc4eY", function(module, exports) {
$parcel$export(module.exports, "useCreateProject", function () { return $1858a0bbdc6c4d80$export$4ad6f12a4acf1a5d; });
$parcel$export(module.exports, "getGenericSampleVersion", function () { return $1858a0bbdc6c4d80$export$3426854b28a53918; });
$parcel$export(module.exports, "generateSequentialDueDates", function () { return $1858a0bbdc6c4d80$export$90369fa9deec58cf; });
$parcel$export(module.exports, "getElapsedDaysFromNow", function () { return $1858a0bbdc6c4d80$export$c4241c86dded1d4f; });
$parcel$export(module.exports, "Transition", function () { return $1858a0bbdc6c4d80$export$be58926105124dd4; });
$parcel$export(module.exports, "Priority", function () { return $1858a0bbdc6c4d80$export$300334f671c43555; });
$parcel$export(module.exports, "getDateDaysFromNow", function () { return $1858a0bbdc6c4d80$export$d64608554c50f764; });
$parcel$export(module.exports, "onLoadingStep", function () { return $1858a0bbdc6c4d80$export$d92ed452cfe7d962; });
$parcel$export(module.exports, "useBulkEmailInvite", function () { return $1858a0bbdc6c4d80$export$f1d2149f1faeaf3c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $1oC0p = parcelRequire("1oC0p");

var $Il3dn = parcelRequire("Il3dn");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7XYQW = parcelRequire("7XYQW");

var $aHTfr = parcelRequire("aHTfr");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $PE2DD = parcelRequire("PE2DD");

var $ea4mV = parcelRequire("ea4mV");

var $lcW33 = parcelRequire("lcW33");

var $f8cLT = parcelRequire("f8cLT");

var $6Su3q = parcelRequire("6Su3q");

var $57QWi = parcelRequire("57QWi");

var $dyF1t = parcelRequire("dyF1t");

var $93Cjr = parcelRequire("93Cjr");
const $1858a0bbdc6c4d80$var$PROJECT_CREATE_TASK_POLLING_TIMEOUT = 30000;
const $1858a0bbdc6c4d80$var$setProjectCreateTaskIdQueryParam = (taskId)=>{
    const url = new URL(window.location.href);
    if (url) {
        url.searchParams.set("taskId", taskId);
        window.history.replaceState({}, "", url.toString());
    }
};
const $1858a0bbdc6c4d80$export$4ad6f12a4acf1a5d = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { user: user } = (0, $doAVE.useUserContext)();
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { toDoColumnName: toDoColumnName, inProgressColumnName: inProgressColumnName, doneColumnName: doneColumnName } = (0, $1oC0p.useMemo)(()=>{
        const toDoColumnName = intl.formatMessage((0, $93Cjr.issueTypeMessages).todoColumnName);
        const inProgressColumnName = intl.formatMessage((0, $93Cjr.issueTypeMessages).inProgressColumnName);
        const doneColumnName = intl.formatMessage((0, $93Cjr.issueTypeMessages).doneColumnName);
        return {
            toDoColumnName: toDoColumnName,
            inProgressColumnName: inProgressColumnName,
            doneColumnName: doneColumnName
        };
    }, [
        intl
    ]);
    const createDefaultProject = (0, $1oC0p.useCallback)(async ({ context: context, setContext: setContext })=>{
        const { template: template = "KANBAN", tenantId: tenantId = "", spaceName: spaceName = "", teamType: teamType = "" } = context;
        $1858a0bbdc6c4d80$export$71480087bc4506a9(context);
        try {
            const projectKey = $1858a0bbdc6c4d80$export$5f5457c3567dd872(teamType);
            const { taskId: taskId } = await stargateClient.postProjectCreate({
                projectName: spaceName,
                cloudId: tenantId,
                template: template,
                issueTypes: (0, $dyF1t.confiugredIssueTypes),
                statusNames: [
                    toDoColumnName,
                    inProgressColumnName,
                    doneColumnName
                ],
                teamType: (0, $lcW33.getProductQueryParamTeamType)(teamType),
                customDetail: {
                    enableExtraFields: true,
                    sampleDataVersion: $1858a0bbdc6c4d80$export$3426854b28a53918(teamType, template)
                },
                projectKey: projectKey
            });
            $1858a0bbdc6c4d80$var$setProjectCreateTaskIdQueryParam(taskId);
            createAnalyticsEvent({
                action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_STARTED),
                eventType: "track",
                actionSubject: (0, $dyF1t.PROJECT_CREATE_ANALYTIC_EVENT_NAME),
                attributes: {
                    template: template,
                    teamType: teamType,
                    tenantId: tenantId,
                    flow: (0, $dyF1t.DEFAULT_FLOW)
                }
            }).fire();
            setContext((prevContext)=>(0, $dPABA._)((0, $6ogO3._)({}, prevContext), {
                    taskId: taskId
                }));
            const { status: status, result: result } = await stargateClient.pollTaskUntilComplete(taskId, tenantId, $1858a0bbdc6c4d80$var$PROJECT_CREATE_TASK_POLLING_TIMEOUT);
            if (status === "COMPLETE") {
                const projectId = result === null || result === void 0 ? void 0 : result.projectId;
                setContext((prevContext)=>(0, $dPABA._)((0, $6ogO3._)({}, prevContext), {
                        projectId: projectId
                    }));
                createAnalyticsEvent({
                    action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_SUCCEEDED),
                    eventType: "track",
                    actionSubject: (0, $dyF1t.PROJECT_CREATE_ANALYTIC_EVENT_NAME),
                    attributes: {
                        template: template,
                        teamType: teamType,
                        tenantId: tenantId,
                        flow: (0, $dyF1t.DEFAULT_FLOW)
                    }
                }).fire();
            }
            if (status !== "COMPLETE") throw new Error("Project creation did not complete successfully");
        } catch (error) {
            $1858a0bbdc6c4d80$export$90f1778a9a15554f(createAnalyticsEvent, {
                error: error,
                template: template,
                teamType: teamType,
                tenantId: tenantId,
                flow: (0, $dyF1t.DEFAULT_FLOW)
            });
        }
    }, [
        stargateClient,
        toDoColumnName,
        inProgressColumnName,
        doneColumnName,
        createAnalyticsEvent
    ]);
    const createMadlibProject = (0, $1oC0p.useCallback)(async ({ context: context, setContext: setContext })=>{
        const { template: template = "KANBAN", tenantId: tenantId = "", spaceName: spaceName = "", teamType: teamType = "", data: data = {
            task: "",
            goal: "",
            dueDate: new Date().getTime()
        } } = context;
        $1858a0bbdc6c4d80$export$71480087bc4506a9(context);
        try {
            const response = await stargateClient.postMadlibContentGeneration(tenantId, {
                spaceName: spaceName,
                workingOnSummary: data.task,
                goal: data.goal,
                teamType: (0, $lcW33.getIdentityTeamType)(teamType)
            });
            createAnalyticsEvent({
                action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_SUCCEEDED),
                eventType: "track",
                actionSubject: (0, $dyF1t.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
                attributes: {
                    template: template,
                    teamType: teamType,
                    tenantId: tenantId,
                    flow: (0, $dyF1t.MADLIB_FLOW)
                }
            }).fire();
            const sampleIssues = $1858a0bbdc6c4d80$var$mapMadlibResponseToSampleIssues(response, data.dueDate, intl, user.accountId);
            const projectKey = $1858a0bbdc6c4d80$export$5f5457c3567dd872(teamType);
            const { taskId: taskId } = await stargateClient.postProjectCreate({
                projectName: spaceName,
                cloudId: tenantId,
                template: template,
                issueTypes: (0, $dyF1t.confiugredIssueTypes),
                statusNames: [
                    toDoColumnName,
                    inProgressColumnName,
                    doneColumnName
                ],
                teamType: (0, $lcW33.getProductQueryParamTeamType)(teamType),
                customDetail: {
                    enableExtraFields: true,
                    sampleDataVersion: "MANUAL"
                },
                projectKey: projectKey,
                sampleIssues: sampleIssues
            });
            $1858a0bbdc6c4d80$var$setProjectCreateTaskIdQueryParam(taskId);
            createAnalyticsEvent({
                action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_STARTED),
                eventType: "track",
                actionSubject: (0, $dyF1t.PROJECT_CREATE_ANALYTIC_EVENT_NAME),
                attributes: {
                    template: template,
                    teamType: teamType,
                    tenantId: tenantId,
                    flow: (0, $dyF1t.MADLIB_FLOW)
                }
            }).fire();
            setContext((prevContext)=>(0, $dPABA._)((0, $6ogO3._)({}, prevContext), {
                    taskId: taskId
                }));
            const { status: status, result: result } = await stargateClient.pollTaskUntilComplete(taskId, tenantId, $1858a0bbdc6c4d80$var$PROJECT_CREATE_TASK_POLLING_TIMEOUT);
            if (status === "COMPLETE") {
                const projectId = result === null || result === void 0 ? void 0 : result.projectId;
                setContext((prevContext)=>(0, $dPABA._)((0, $6ogO3._)({}, prevContext), {
                        projectId: projectId
                    }));
                createAnalyticsEvent({
                    action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_SUCCEEDED),
                    eventType: "track",
                    actionSubject: (0, $dyF1t.PROJECT_CREATE_ANALYTIC_EVENT_NAME),
                    attributes: {
                        template: template,
                        teamType: teamType,
                        tenantId: tenantId,
                        flow: (0, $dyF1t.MADLIB_FLOW)
                    }
                }).fire();
            } else throw new Error("Project creation did not complete successfully");
        } catch (error) {
            $1858a0bbdc6c4d80$export$90f1778a9a15554f(createAnalyticsEvent, {
                error: error,
                template: template,
                teamType: teamType,
                tenantId: tenantId,
                flow: (0, $dyF1t.MADLIB_FLOW)
            });
            // Attempt default project creation if Content Generation or Madlib project creation fails
            if (error instanceof (0, $PE2DD.MadlibContentGenerationError) || error instanceof (0, $PE2DD.ProjectCreateError)) await createDefaultProject({
                context: context,
                setContext: setContext
            });
        }
    }, [
        createDefaultProject,
        stargateClient,
        toDoColumnName,
        inProgressColumnName,
        doneColumnName,
        user.accountId,
        intl,
        createAnalyticsEvent
    ]);
    return {
        createMadlibProject: createMadlibProject,
        createDefaultProject: createDefaultProject
    };
};
const $1858a0bbdc6c4d80$export$90369fa9deec58cf = (endDate, numberOfIssues)=>{
    // Generate well-spaced sequential due dates for child issues (all at midnight)
    const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($Il3dn)))().startOf("day");
    const finalDate = (0, (/*@__PURE__*/$parcel$interopDefault($Il3dn)))(endDate).startOf("day");
    const totalDays = finalDate.diff(startDate, "days");
    // Divide the day range into intervals and randomly select a day within each interval
    // This ensures even distribution across the entire date range
    const intervalSizeInDays = totalDays / numberOfIssues;
    return Array.from({
        length: numberOfIssues
    }, (_, index)=>{
        // Calculate the day range for this interval
        const intervalStartDay = Math.floor(index * intervalSizeInDays);
        const intervalEndDay = Math.floor((index + 1) * intervalSizeInDays);
        // Randomly select a day within this interval (ensure at least 1 day range)
        const randomDay = intervalStartDay + Math.floor(Math.random() * Math.max(1, intervalEndDay - intervalStartDay));
        // Return date at midnight
        return startDate.clone().add(randomDay, "days").format("YYYY-MM-DD");
    });
};
const $1858a0bbdc6c4d80$var$mapMadlibResponseToSampleIssues = (response, dueDate, intl, accountId)=>{
    const { childWorkItems: childWorkItems } = response.sampleIssues;
    const relativeDays = $1858a0bbdc6c4d80$export$c4241c86dded1d4f(dueDate);
    const issueDueDates = $1858a0bbdc6c4d80$export$90369fa9deec58cf(dueDate, childWorkItems.length);
    const issueDueDateRelativeDays = issueDueDates.map((issueDueDate)=>$1858a0bbdc6c4d80$export$c4241c86dded1d4f(new Date(issueDueDate).getTime()));
    const EMPTY_DESCRIPTION = "";
    const childrenIssues = childWorkItems.map((issue, index)=>{
        var _issueDueDateRelativeDays_index;
        return {
            refId: `task-${index + 1}`,
            parentRefId: undefined,
            issueType: "Task",
            summary: issue.summary,
            description: EMPTY_DESCRIPTION,
            transitionId: $1858a0bbdc6c4d80$export$be58926105124dd4.ToDo,
            relativeDays: (_issueDueDateRelativeDays_index = issueDueDateRelativeDays[index]) !== null && _issueDueDateRelativeDays_index !== void 0 ? _issueDueDateRelativeDays_index : relativeDays,
            priorityId: $1858a0bbdc6c4d80$export$300334f671c43555.Medium,
            assigneeId: undefined
        };
    });
    const manualIssue = {
        refId: "manual-1",
        parentRefId: undefined,
        issueType: "Task",
        summary: intl.formatMessage((0, $93Cjr.manualIssueMessages).summary),
        description: intl.formatMessage((0, $93Cjr.manualIssueMessages).description),
        transitionId: $1858a0bbdc6c4d80$export$be58926105124dd4.Done,
        relativeDays: 0,
        priorityId: $1858a0bbdc6c4d80$export$300334f671c43555.Low,
        assigneeId: accountId
    };
    return childrenIssues.concat([
        manualIssue
    ]);
};
const $1858a0bbdc6c4d80$export$c4241c86dded1d4f = (timestamp)=>{
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($Il3dn)))();
    const targetDate = (0, (/*@__PURE__*/$parcel$interopDefault($Il3dn)))(timestamp);
    return targetDate.diff(now, "days");
};
const $1858a0bbdc6c4d80$export$d64608554c50f764 = (daysFromNow)=>Date.now() + daysFromNow * 86400000;
const $1858a0bbdc6c4d80$export$be58926105124dd4 = {
    ToDo: 11,
    InProgress: 21,
    Done: 31
};
const $1858a0bbdc6c4d80$export$300334f671c43555 = {
    Highest: 1,
    High: 2,
    Medium: 3,
    Low: 4,
    Lowest: 5
};
const $1858a0bbdc6c4d80$export$5f5457c3567dd872 = (teamType)=>{
    switch(teamType){
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE:
            return "DEV";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT:
            return "IT";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DESIGN:
            return "DES";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE:
            return "CS";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_HR:
            return "HR";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_MARKETING:
            return "MKT";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS:
            return "OPS";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_FINANCE:
            return "FNC";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_LEGAL:
            return "LGL";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SALES:
            return "SAL";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT:
            return "PDM";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT:
            return "PJM";
        case 0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE:
            return "DS";
        default:
            return "PROJ";
    }
};
const $1858a0bbdc6c4d80$export$90f1778a9a15554f = (createAnalyticsEvent, { error: error, template: template, teamType: teamType, tenantId: tenantId, flow: flow })=>{
    if (error instanceof (0, $PE2DD.MadlibContentGenerationError)) createAnalyticsEvent({
        action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_FAILED),
        eventType: "track",
        actionSubject: (0, $dyF1t.MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME),
        attributes: {
            template: template,
            teamType: teamType,
            tenantId: tenantId,
            flow: flow,
            message: error.message
        }
    }).fire();
    if (error instanceof (0, $PE2DD.ProjectCreateError)) createAnalyticsEvent({
        action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_FAILED),
        eventType: "track",
        actionSubject: (0, $dyF1t.PROJECT_CREATE_ANALYTIC_EVENT_NAME),
        attributes: {
            template: template,
            teamType: teamType,
            tenantId: tenantId,
            flow: flow,
            message: error.message
        }
    }).fire();
    if (error instanceof (0, $PE2DD.TaskError)) createAnalyticsEvent({
        action: (0, $dyF1t.ANALYTIC_EVENT_ACTION_FAILED),
        eventType: "track",
        actionSubject: (0, $dyF1t.PROJECT_POLLING_ANALYTIC_EVENT_NAME),
        attributes: {
            template: template,
            teamType: teamType,
            tenantId: tenantId,
            flow: flow,
            message: error.message
        }
    }).fire();
};
const $1858a0bbdc6c4d80$export$3426854b28a53918 = (teamType, template)=>{
    // This was the targeting for GENERICV2 at launch and it's retrictive to these team types in the backend.
    if (teamType === (0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE) && template === "KANBAN" || template === "SCRUM") return "GENERICV2";
    return "GENERIC";
};
const $1858a0bbdc6c4d80$export$71480087bc4506a9 = (context)=>{
    // This experiment targets non-software team types with Kanban template
    if (context.teamType !== (0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE) && context.template === "KANBAN") (0, $ea4mV.getExperimentWithExposures)((0, $ea4mV.experiments).jfindSimplifiedListViewWithBasicTasks);
    // This experiment targets software team type with Kanban or all team types with Scrum
    if (context.teamType === (0, $7XYQW.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE) && context.template === "KANBAN" || context.template === "SCRUM") (0, $ea4mV.getExperimentWithExposures)((0, $ea4mV.experiments).jfindBasicSampleTasksForScrumOrSoftwareKanban);
};
const $1858a0bbdc6c4d80$export$901b114f384ac559 = 3000;
const $1858a0bbdc6c4d80$export$d92ed452cfe7d962 = async ({ context: context })=>{
    const workPromise = (async ()=>{
        for (const val of context.promisesToResolve){
            if (val instanceof Promise) await val.catch(()=>{
            /* swallow errors */ });
            if (typeof val === "function") await val().catch(()=>{
            /* swallow errors */ });
        }
    })();
    const loadingBufferPromise = new Promise((resolve)=>setTimeout(resolve, $1858a0bbdc6c4d80$export$901b114f384ac559));
    await Promise.all([
        workPromise,
        loadingBufferPromise
    ]);
};
const $1858a0bbdc6c4d80$export$f1d2149f1faeaf3c = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const postBulkEmailInvite = (0, $1oC0p.useCallback)(async ({ context: context })=>{
        try {
            const { tenantId: tenantId, emailList: emailList, taskId: taskId } = context;
            // do not request invites if email list is empty
            if (!emailList || emailList.length === 0) return;
            // do not request invites if projectId is not defined
            if (!taskId) {
                console.warn("project task id is not defined, skipping invites");
                return;
            }
            (0, $7VwhR.ufoEventOnboardingInviteUsers).startSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK);
            const { result: { projectId: projectId } } = await stargateClient.pollTaskUntilComplete(taskId, tenantId, $1858a0bbdc6c4d80$var$PROJECT_CREATE_TASK_POLLING_TIMEOUT);
            (0, $7VwhR.ufoEventOnboardingInviteUsers).endSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK);
            (0, $7VwhR.ufoEventOnboardingInviteUsers).startSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_FETCHING_ROLES);
            // get project roles
            const roles = await stargateClient.fetchProjectRoles(tenantId, projectId);
            (0, $7VwhR.ufoEventOnboardingInviteUsers).endSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_FETCHING_ROLES);
            const memberRole = (0, $f8cLT.findRoleIdWithName)([
                "member",
                "user"
            ], roles);
            const adminRole = (0, $f8cLT.findRoleIdWithName)([
                "administrator"
            ], roles);
            let inviteeRoleId = memberRole;
            let jiraEdition;
            // elevating invited user to Admin for Free Edtition requires Admin role is available
            if (adminRole) try {
                (0, $7VwhR.ufoEventOnboardingInviteUsers).startSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_CHECKING_LICENSE);
                const licenseInformation = await stargateClient.getLicenceInformationStatus({
                    cloudId: tenantId
                });
                jiraEdition = (0, $6Su3q.parseJiraEditionFromLicenseInformation)(licenseInformation);
                if (jiraEdition === "free") inviteeRoleId = adminRole;
                (0, $7VwhR.ufoEventOnboardingInviteUsers).endSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_CHECKING_LICENSE);
            } catch (e) {
                createAnalyticsEvent({
                    action: "failed",
                    actionSubject: "getLicenceInformationStatus",
                    eventType: "track",
                    attributes: {
                        tenantId: context.tenantId,
                        projectId: context.projectId,
                        template: context.template,
                        teamType: context.teamType
                    }
                }).fire();
            }
            const continueUrl = (0, $57QWi.generateContinueUrl)(projectId);
            const atlOrigin = new (0, $aHTfr.default)({
                product: "jira"
            }).encode();
            let successfulInvites = 0;
            let failedInvites = 0;
            (0, $7VwhR.ufoEventOnboardingInviteUsers).startSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS);
            const invites = emailList.map(async (email)=>{
                const inviteBody = {
                    email: email,
                    projectRoleIds: [
                        inviteeRoleId
                    ],
                    continueUrl: continueUrl,
                    atlOrigin: atlOrigin
                };
                // request invites
                return stargateClient.postEmailInvite(tenantId, projectId, inviteBody)// deterime how many invites succeeded for analytics
                .then(()=>{
                    successfulInvites++;
                }).catch((error)=>{
                    failedInvites++;
                    createAnalyticsEvent({
                        action: "failed",
                        actionSubject: "onboardingWizardInviteStepInviteRequest",
                        eventType: "operational",
                        attributes: {
                            error: error instanceof Error ? error.message : String(error),
                            path: `/ex/jira/${tenantId}/rest/internal/latest/invite-user/request-access/project/${projectId}`,
                            projectId: projectId,
                            inviteeRoleId: inviteeRoleId,
                            jiraEdition: jiraEdition,
                            tenantId: context.tenantId,
                            template: context.template,
                            teamType: context.teamType
                        }
                    }).fire();
                });
            });
            const results = await Promise.allSettled(invites);
            (0, $7VwhR.ufoEventOnboardingInviteUsers).endSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS);
            createAnalyticsEvent({
                action: "succeeded",
                actionSubject: "bulkEmailInvite",
                eventType: "track",
                attributes: {
                    totalInvites: results.length,
                    successfulInvites: successfulInvites,
                    failedInvites: failedInvites,
                    projectId: projectId,
                    inviteeRoleId: inviteeRoleId,
                    jiraEdition: jiraEdition,
                    tenantId: context.tenantId,
                    template: context.template,
                    teamType: context.teamType
                }
            }).fire();
            return;
        } catch (e) {
            createAnalyticsEvent({
                action: "failed",
                actionSubject: "bulkEmailInvite",
                eventType: "track",
                attributes: {
                    tenantId: context.tenantId,
                    projectId: context.projectId,
                    template: context.template,
                    teamType: context.teamType
                }
            }).fire();
        }
    }, [
        stargateClient,
        createAnalyticsEvent
    ]);
    return {
        postBulkEmailInvite: postBulkEmailInvite
    };
};

});
parcelRegister("f8cLT", function(module, exports) {
$parcel$export(module.exports, "useJfind1663FetchProjectRoleIds", function () { return $8ab076290e71ded1$export$5f511ba41c6027d5; });
$parcel$export(module.exports, "findRoleIdWithName", function () { return $8ab076290e71ded1$export$5e88e5c1427e7adf; });

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $PE2DD = parcelRequire("PE2DD");
const $8ab076290e71ded1$var$EMPTY = {
    viewer: null,
    member: null,
    admin: null
};
const $8ab076290e71ded1$export$5f511ba41c6027d5 = ()=>{
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [hasFetched, setHasFetched] = (0, $1oC0p.useState)(false);
    const [result, setResult] = (0, $1oC0p.useState)($8ab076290e71ded1$var$EMPTY);
    const fetchRoles = async (cloudId, projectId)=>{
        if (!cloudId || !projectId) return Promise.resolve($8ab076290e71ded1$var$EMPTY);
        if (hasFetched) return Promise.resolve(result);
        try {
            const roles = await stargateClient.fetchProjectRoles(cloudId, projectId);
            const viewer = $8ab076290e71ded1$export$5e88e5c1427e7adf([
                "viewer"
            ], roles);
            const member = $8ab076290e71ded1$export$5e88e5c1427e7adf([
                "member",
                "user"
            ], roles);
            const admin = $8ab076290e71ded1$export$5e88e5c1427e7adf([
                "administrator"
            ], roles);
            setResult({
                viewer: viewer,
                member: member,
                admin: admin
            });
            setHasFetched(true);
            return Promise.resolve({
                viewer: viewer,
                member: member,
                admin: admin
            });
        } catch (error) {
            createAnalyticsEvent({
                eventType: "track",
                action: "failed_to_fetch_project_roles",
                actionSubject: "jfind_1663_onboarding_wizard",
                attributes: {
                    cloudId: cloudId,
                    projectId: projectId,
                    error: error.message
                }
            });
            setHasFetched(true); // only attempt once
        }
        return Promise.resolve($8ab076290e71ded1$var$EMPTY);
    };
    return {
        fetchRoles: fetchRoles
    };
};
const $8ab076290e71ded1$export$5e88e5c1427e7adf = (matching, roles)=>{
    var _roles_role;
    const role = Object.keys(roles).find((role)=>matching.includes(role.toLowerCase()));
    if (!role) return null;
    // formatted '.../rest/api/3/project/projectId/ role/ projectRoleId'
    const id = (_roles_role = roles[role]) === null || _roles_role === void 0 ? void 0 : _roles_role.split("role/").at(1);
    return id ? Number(id) : null;
};

});

parcelRegister("6Su3q", function(module, exports) {
$parcel$export(module.exports, "getInviteeProjectRoleId", function () { return $695df9732fe52c82$export$c0243e7bdfa7663e; });
$parcel$export(module.exports, "requestHandlers", function () { return $695df9732fe52c82$export$554d4ec26f54f869; });
$parcel$export(module.exports, "parseJiraEditionFromLicenseInformation", function () { return $695df9732fe52c82$export$46696ba2a03c9f48; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VwhR = parcelRequire("7VwhR");

var $32ng3 = parcelRequire("32ng3");

var $jrKsm = parcelRequire("jrKsm");

var $57QWi = parcelRequire("57QWi");

var $jEMF4 = parcelRequire("jEMF4");
const $695df9732fe52c82$export$c0243e7bdfa7663e = (projectRoleIds, preferAdminRole = false)=>{
    if (!projectRoleIds) return null;
    if (preferAdminRole) return projectRoleIds.admin || projectRoleIds.member || projectRoleIds.viewer || null;
    // fallback order to ensure at least one role is assigned
    return projectRoleIds.member || projectRoleIds.admin || projectRoleIds.viewer || null;
};
const $695df9732fe52c82$var$formatPrefix = (cloudId)=>(0, $jEMF4.TENANT_AWARE_REDIRECT).replace("$cloudId", cloudId);
const $695df9732fe52c82$export$6da9c40173ae2a57 = async (fetchRef, params, args)=>{
    const [, config] = params;
    const { cloudId: cloudId } = args;
    const tenantAwarePath = $695df9732fe52c82$var$formatPrefix(cloudId);
    const modifiedResource = `${tenantAwarePath}${(0, $jEMF4.InternalJiraEndpoints).JIRA_PERMISSIONS}?permissions=USER_PICKER`;
    return fetchRef(modifiedResource, config);
};
const $695df9732fe52c82$export$fdbfe5a21acd723f = async (fetchRef, params, args)=>{
    (0, $7VwhR.ufoEventOnboardingInviteUsers).startSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS);
    const [, config] = params;
    const { cloudId: cloudId, projectId: projectId, inviteeRoleId: inviteeRoleId } = args;
    const tenantAwarePath = $695df9732fe52c82$var$formatPrefix(cloudId);
    if (!projectId || !(config === null || config === void 0 ? void 0 : config.body) || !inviteeRoleId) return fetchRef(...params);
    const modifiedResource = `${tenantAwarePath}${(0, $jEMF4.InternalJiraEndpoints).JIRA_INVITE_USER}/${projectId}`;
    const body = JSON.parse(config.body);
    const modifiedBody = (0, $dPABA._)((0, $6ogO3._)({}, body), {
        projectRoleIds: inviteeRoleId ? [
            inviteeRoleId
        ] : [],
        continueUrl: (0, $57QWi.generateContinueUrl)(projectId),
        atlOrigin: (0, $jrKsm.extractAtlOriginFromUrl)(body.continueUrl || "")
    });
    const modifiedConfig = (0, $dPABA._)((0, $6ogO3._)({}, config), {
        body: JSON.stringify(modifiedBody)
    });
    return fetchRef(modifiedResource, modifiedConfig);
};
const $695df9732fe52c82$export$beff6584eb52db63 = async (fetchRef, params, args)=>{
    var _results_;
    const analyticsImprovementEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jfind1663ImproveInviteAnalytics);
    (0, $7VwhR.ufoEventOnboardingInviteUsers).startSubstep((0, $7VwhR.UfoCustomTimingKey).JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS);
    const [, config] = params;
    const { cloudId: cloudId, projectId: projectId, inviteeRoleId: inviteeRoleId, onComplete: onComplete, onError: onError } = args;
    const tenantAwarePath = $695df9732fe52c82$var$formatPrefix(cloudId);
    if (!projectId || !(config === null || config === void 0 ? void 0 : config.body) || !inviteeRoleId) return fetchRef(...params);
    // redirect Bulk Invite call to Jira internal Invite endpoint
    const modifiedResource = `${tenantAwarePath}${(0, $jEMF4.InternalJiraEndpoints).JIRA_INVITE_USER}/${projectId}`;
    const body = JSON.parse(config.body);
    const emails = body.users || [];
    if (!emails.length || emails.length > 10) // 10 is Invite People's maximum allowed invites per request
    return fetchRef(...params);
    const continueUrl = (0, $57QWi.generateContinueUrl)(projectId);
    const atlOrigin = (0, $jrKsm.extractAtlOriginFromUrl)(body.continueUrl || "");
    // for each email added, create a separate invite request and invite all in parallel
    const invites = emails.map(({ email: email })=>{
        const inviteBody = {
            email: email,
            projectRoleIds: inviteeRoleId ? [
                inviteeRoleId
            ] : [],
            continueUrl: continueUrl,
            atlOrigin: atlOrigin
        };
        const inviteCofig = (0, $dPABA._)((0, $6ogO3._)({}, config), {
            body: JSON.stringify(inviteBody)
        });
        return fetchRef(modifiedResource, inviteCofig);
    });
    const results = await Promise.allSettled(invites);
    // deterime how many invites succeeded for analytics
    const successfulInvites = results.filter((result)=>result.status === "fulfilled" && result.value.ok);
    const failedInvites = results.filter((result)=>result.status === "rejected" || !result.value.ok);
    await (onComplete === null || onComplete === void 0 ? void 0 : onComplete({
        totalInvites: results.length,
        successfulInvites: successfulInvites.length,
        failedInvites: failedInvites.length
    }));
    if (analyticsImprovementEnabled && onError) results.forEach((result)=>$695df9732fe52c82$var$formatAndFireOnError(result, onError));
    // Return first result to satisfy the expected return type of Response, or a fallback
    if (((_results_ = results[0]) === null || _results_ === void 0 ? void 0 : _results_.status) === "fulfilled") return results[0].value;
    // as a default, make original call
    return fetchRef(...params);
};
const $695df9732fe52c82$export$554d4ec26f54f869 = {
    [(0, $jEMF4.InternalJiraEndpoints).JIRA_PERMISSIONS]: $695df9732fe52c82$export$6da9c40173ae2a57,
    [(0, $jEMF4.InternalJiraEndpoints).JIRA_INVITE_USER]: $695df9732fe52c82$export$fdbfe5a21acd723f,
    [(0, $jEMF4.InternalJiraEndpoints).JIRA_INVITE_USER_FALLBACK]: $695df9732fe52c82$export$beff6584eb52db63
};
const $695df9732fe52c82$var$formatAndFireOnError = (result, onError)=>{
    if (result.status === "fulfilled" && !result.value.ok) {
        const clone = result.value.clone(); // cloning to preserve original responses after interception
        clone.json().then((asJson)=>{
            onError({
                error: asJson || "Unknown error",
                status: clone.status,
                statusText: clone.statusText
            });
        }).catch();
    } else if (result.status === "rejected") onError({
        error: result.reason || "Unknown error: promise rejected"
    });
};
const $695df9732fe52c82$export$46696ba2a03c9f48 = (response)=>{
    var _response_products_JIRA_PRODUCT_KEY;
    var _response_products_JIRA_PRODUCT_KEY_edition;
    return (_response_products_JIRA_PRODUCT_KEY_edition = (_response_products_JIRA_PRODUCT_KEY = response.products[0, $jEMF4.JIRA_PRODUCT_KEY]) === null || _response_products_JIRA_PRODUCT_KEY === void 0 ? void 0 : _response_products_JIRA_PRODUCT_KEY.edition) !== null && _response_products_JIRA_PRODUCT_KEY_edition !== void 0 ? _response_products_JIRA_PRODUCT_KEY_edition : "premium";
};

});
parcelRegister("jrKsm", function(module, exports) {
$parcel$export(module.exports, "extractAtlOriginFromUrl", function () { return $415aba047f8994be$export$ca00efdf7987c260; });
/**
 * Extracts the atlOrigin parameter from a URL string
 * @param url - The URL to extract atlOrigin from
 * @returns The atlOrigin value or empty string if not found
 */ const $415aba047f8994be$export$ca00efdf7987c260 = (url)=>{
    try {
        const urlParams = new URLSearchParams(url.split("?")[1] || "");
        return urlParams.get("atlOrigin") || "";
    } catch (e) {
        return "";
    }
};

});

parcelRegister("57QWi", function(module, exports) {
$parcel$export(module.exports, "generateContinueUrl", function () { return $8916e3cb6b4efaea$export$cb613d5e6836d723; });
$parcel$export(module.exports, "generateShareLink", function () { return $8916e3cb6b4efaea$export$5a15fc2945662334; });
$parcel$export(module.exports, "POPOVER_DURATION", function () { return $8916e3cb6b4efaea$export$bcf60058488c876; });
$parcel$export(module.exports, "getEmailListAnalytics", function () { return $8916e3cb6b4efaea$export$dff5fa3c9196074d; });

var $aHTfr = parcelRequire("aHTfr");

var $7VwhR = parcelRequire("7VwhR");

var $eRzlV = parcelRequire("eRzlV");
const $8916e3cb6b4efaea$var$getSite = ()=>{
    const searchParams = new URLSearchParams(globalThis.location.search);
    var _searchParams_get;
    return (_searchParams_get = searchParams.get("ondemandurl")) !== null && _searchParams_get !== void 0 ? _searchParams_get : "";
};
const $8916e3cb6b4efaea$var$getOrigin = ()=>{
    return (0, $eRzlV.isProduction)() ? ".atlassian.net" : ".jira-dev.com";
};
const $8916e3cb6b4efaea$export$cb613d5e6836d723 = (projectId)=>{
    const site = $8916e3cb6b4efaea$var$getSite();
    const origin = $8916e3cb6b4efaea$var$getOrigin();
    const queryParams = `${projectId ? `?projectId=${projectId}` : ""}`;
    return `https://${site}${origin}/welcome/software${queryParams}`;
};
const $8916e3cb6b4efaea$export$5a15fc2945662334 = ()=>{
    const site = $8916e3cb6b4efaea$var$getSite();
    const origin = $8916e3cb6b4efaea$var$getOrigin();
    const continueUrl = encodeURIComponent($8916e3cb6b4efaea$export$cb613d5e6836d723());
    const shareLink = `https://${site}${origin}?continue=${continueUrl}`;
    const withTracing = new (0, $aHTfr.default)({
        product: "jira"
    }).addToUrl(shareLink);
    return {
        link: withTracing
    };
};
const $8916e3cb6b4efaea$export$bcf60058488c876 = 2000;
const $8916e3cb6b4efaea$export$bbfa9b24c43772e3 = (email)=>{
    const domain = email.split("@")[1];
    return domain ? domain.toLowerCase() : "";
};
const $8916e3cb6b4efaea$export$c3a3240a17b6712 = (emails)=>{
    if (emails.length <= 1) return false;
    const uniqueDomains = $8916e3cb6b4efaea$export$271463dc013c475e(emails);
    return uniqueDomains.length > 1;
};
const $8916e3cb6b4efaea$export$271463dc013c475e = (emails)=>{
    const domains = emails.map($8916e3cb6b4efaea$export$bbfa9b24c43772e3).filter((domain)=>domain !== "");
    return [
        ...new Set(domains)
    ];
};
const $8916e3cb6b4efaea$export$dff5fa3c9196074d = (emails)=>{
    const validEmails = emails.filter((email)=>(0, $7VwhR.emailIsValid)(email));
    return {
        emailCount: validEmails.length,
        isCrossDomain: $8916e3cb6b4efaea$export$c3a3240a17b6712(validEmails),
        domains: $8916e3cb6b4efaea$export$271463dc013c475e(validEmails)
    };
};

});

parcelRegister("jEMF4", function(module, exports) {
$parcel$export(module.exports, "InternalJiraEndpoints", function () { return $ca05ae6bdacbb9ad$export$cd9c27b713da7af7; });
$parcel$export(module.exports, "InterceptPaths", function () { return $ca05ae6bdacbb9ad$export$b6ba35dde2233e95; });
$parcel$export(module.exports, "TENANT_AWARE_REDIRECT", function () { return $ca05ae6bdacbb9ad$export$d787425bb0792109; });
$parcel$export(module.exports, "JIRA_PRODUCT_KEY", function () { return $ca05ae6bdacbb9ad$export$e36fc9e5c75fc113; });
var $ca05ae6bdacbb9ad$export$cd9c27b713da7af7 = /*#__PURE__*/ function(InternalJiraEndpoints) {
    InternalJiraEndpoints["JIRA_PERMISSIONS"] = "/rest/api/3/mypermissions";
    InternalJiraEndpoints["JIRA_INVITE_USER"] = "/rest/internal/latest/invite-user/request-access/project";
    InternalJiraEndpoints["JIRA_INVITE_USER_FALLBACK"] = "/gateway/api/invitations/invite";
    return InternalJiraEndpoints;
}({});
const $ca05ae6bdacbb9ad$export$b6ba35dde2233e95 = [
    "/rest/api/3/mypermissions",
    "/rest/internal/latest/invite-user/request-access/project",
    "/gateway/api/invitations/invite"
];
const $ca05ae6bdacbb9ad$export$d787425bb0792109 = "/gateway/api/ex/jira/$cloudId";
const $ca05ae6bdacbb9ad$export$e36fc9e5c75fc113 = "jira-software.ondemand";

});


parcelRegister("dyF1t", function(module, exports) {
$parcel$export(module.exports, "confiugredIssueTypes", function () { return $4d40f1761cdf046d$export$dc1afa03e933c378; });
$parcel$export(module.exports, "ANALYTIC_EVENT_ACTION_SUCCEEDED", function () { return $4d40f1761cdf046d$export$d9bb70073ffb9f9d; });
$parcel$export(module.exports, "ANALYTIC_EVENT_ACTION_STARTED", function () { return $4d40f1761cdf046d$export$d72c787d1e3b9b0f; });
$parcel$export(module.exports, "ANALYTIC_EVENT_ACTION_FAILED", function () { return $4d40f1761cdf046d$export$f862cc8ed27c82d9; });
$parcel$export(module.exports, "PROJECT_CREATE_ANALYTIC_EVENT_NAME", function () { return $4d40f1761cdf046d$export$4f38dc4244d5596; });
$parcel$export(module.exports, "PROJECT_POLLING_ANALYTIC_EVENT_NAME", function () { return $4d40f1761cdf046d$export$5caa1669e37ce07a; });
$parcel$export(module.exports, "MADLIB_CONTENT_GENERATION_ANALYTIC_EVENT_NAME", function () { return $4d40f1761cdf046d$export$d8e28a3050ddc5e2; });
$parcel$export(module.exports, "MADLIB_FLOW", function () { return $4d40f1761cdf046d$export$58796d67e188ffce; });
$parcel$export(module.exports, "DEFAULT_FLOW", function () { return $4d40f1761cdf046d$export$622541bf2852718e; });
$parcel$export(module.exports, "SETUP_SCREEN_INDEX_SPACE_DETAILS", function () { return $4d40f1761cdf046d$export$8ef16456c620c162; });
$parcel$export(module.exports, "SETUP_SCREEN_INDEX_INVITE", function () { return $4d40f1761cdf046d$export$28d0d87a380e3cd7; });
$parcel$export(module.exports, "SETUP_SCREEN_INDEX_FFL_INVITE", function () { return $4d40f1761cdf046d$export$ff3a7842462e009b; });
const $4d40f1761cdf046d$export$dc1afa03e933c378 = [
    {
        name: "Task",
        avatarId: 10318
    }
];
const $4d40f1761cdf046d$export$d9bb70073ffb9f9d = "succeeded";
const $4d40f1761cdf046d$export$d72c787d1e3b9b0f = "started";
const $4d40f1761cdf046d$export$f862cc8ed27c82d9 = "failed";
const $4d40f1761cdf046d$export$4f38dc4244d5596 = "project creation";
const $4d40f1761cdf046d$export$5caa1669e37ce07a = "project polling";
const $4d40f1761cdf046d$export$d8e28a3050ddc5e2 = "madlib content generation";
const $4d40f1761cdf046d$export$58796d67e188ffce = "madlib";
const $4d40f1761cdf046d$export$622541bf2852718e = "default";
const $4d40f1761cdf046d$export$8ef16456c620c162 = 0;
const $4d40f1761cdf046d$export$54014c91f2c88986 = 1;
const $4d40f1761cdf046d$export$28d0d87a380e3cd7 = 2;
const $4d40f1761cdf046d$export$f3d1506e1ddf8859 = 3;
const $4d40f1761cdf046d$export$ff3a7842462e009b = 1;

});

parcelRegister("93Cjr", function(module, exports) {
$parcel$export(module.exports, "issueTypeMessages", function () { return $f1e58e85a5c63082$export$ac866c443441f600; });
$parcel$export(module.exports, "manualIssueMessages", function () { return $f1e58e85a5c63082$export$e8c72aaab82f8117; });

var $fnHPc = parcelRequire("fnHPc");
const $f1e58e85a5c63082$export$ac866c443441f600 = (0, $fnHPc.defineMessages)({
    todoColumnName: {
        id: "jira.madlib.issue-type.todo-column-name",
        defaultMessage: "To Do",
        description: "To Do column name"
    },
    inProgressColumnName: {
        id: "jira.madlib.issue-type.in-progress-column-name",
        defaultMessage: "In Progress",
        description: "In Progress column name"
    },
    doneColumnName: {
        id: "jira.madlib.issue-type.done-column-name",
        defaultMessage: "Done",
        description: "Done column name"
    }
});
const $f1e58e85a5c63082$export$e8c72aaab82f8117 = (0, $fnHPc.defineMessages)({
    summary: {
        id: "jira.madlib.manual-issue.summary",
        defaultMessage: "Add work to tracking tool",
        description: "Summary for the manually created issue"
    },
    description: {
        id: "jira.madlib.manual-issue.description",
        defaultMessage: "Break down work into tasks in Jira to organize work and stay aligned.",
        description: "Description for the manually created issue"
    }
});

});



parcelRegister("6qT9Y", function(module, exports) {
$parcel$export(module.exports, "Background", function () { return $e2fb81374490b4ca$export$668799e4797757a8; });
/* background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $e2fb81374490b4ca$var$backgroundStyle = null;
const $e2fb81374490b4ca$export$668799e4797757a8 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "1440",
        height: "900",
        viewBox: "0 0 1440 900",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_kqswstnw _1e02idpf _u7coidpf _1bsbauwl _p12fauwl _1ul91fbq _1pby1mrw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M789.13 1872.04C965.261 1810.52 1109.36 1831.72 1247.84 1924.87C1398.51 2026.22 1474.44 2166.31 1480.18 2336.89L2764.78 3200.99C3259.46 2083.95 3014.99 1156.25 2171.57 588.917C1386.05 60.5259 585.163 101.12 -487 1013.63L789.468 1872.27L789.13 1872.04Z",
            fill: "#CFE1FD"
        })
    });
};

});

parcelRegister("aBUAq", function(module, exports) {
$parcel$export(module.exports, "PreviewTable", function () { return $ac5d463a4909f1e1$export$17497d5d2ced1033; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $FapDU = parcelRequire("FapDU");

var $kbpa7 = parcelRequire("kbpa7");

var $j0ZBv = parcelRequire("j0ZBv");

var $hSlTI = parcelRequire("hSlTI");
const $ac5d463a4909f1e1$var$TABLE_HEADERS = [
    "Work",
    "Status",
    "Due date",
    "Priority",
    "Assignee"
];
const $ac5d463a4909f1e1$var$tableContainerCss = null;
const $ac5d463a4909f1e1$var$tableCss = null;
const $ac5d463a4909f1e1$var$tableCellHeaderCss = null;
const $ac5d463a4909f1e1$var$teamTypeCss = null;
const $ac5d463a4909f1e1$var$loadingBarCss = null;
const $ac5d463a4909f1e1$var$teamTypeLoadingCss = null;
const $ac5d463a4909f1e1$export$17497d5d2ced1033 = ({ rows: rows, spaceName: spaceName })=>{
    const headerCells = $ac5d463a4909f1e1$var$TABLE_HEADERS.map((columnHeader)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("th", {
            className: (0, $2jatx.default)([
                "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                "_bfhk1rga _k48p1fw0 _1wyb1yny _syaz1yg0 _1ezzlvwl _12ornqa1 _1r62t94y _y3gnv2br",
                columnHeader !== "Assignee" && "_pxtolvwl _1vn8nqa1 _1ej8t94y"
            ]),
            style: {
                "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100")),
                "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
            },
            children: columnHeader
        }, `column-header-${columnHeader}`);
    });
    const defaultRowCount = 6;
    const rowCount = (rows === null || rows === void 0 ? void 0 : rows.length) || defaultRowCount;
    const rowCells = Array.from({
        length: rowCount
    }, (_, i)=>{
        const isLastRow = i === rowCount - 1;
        if (rows && rows.length > 0 && rows[i]) {
            const { type: type, summary: summary, status: status, dueDate: dueDate, priority: priority, assignee: assignee, assigneeImgSrc: assigneeImgSrc } = rows[i];
            // Ensure first row defaults to epic if type is missing/undefined (only for Kanban)
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hSlTI.TableRow), {
                type: type,
                summary: summary,
                status: status,
                dueDate: dueDate,
                priority: priority,
                assignee: assignee,
                assigneeImgSrc: assigneeImgSrc,
                isLastRow: isLastRow
            }, "row-" + i);
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hSlTI.TableRow), {
            type: i === 0 ? "epic" : "task",
            isLastRow: isLastRow
        }, "row-" + i);
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("h3", {
                className: (0, $2jatx.default)([
                    "_ect41roz _k48p8n31 _1wyb6zda _vwz49c5v _syazpmk4 _1e0c1txw _4cvr1h6o _gy1p1o4k _1bsb1osq _p12fxwiq _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rthimiu"
                ]),
                style: {
                    "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j0ZBv.ProjectAvatar), {}),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: spaceName ? spaceName : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                                    children: "Generating your Jira space"
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                                        "_1bsb1o99"
                                    ])
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsbxwiq _p12f1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug _154015zi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("table", {
                    className: (0, $2jatx.default)([
                        "_1kqm1wug _2rko1mvu _yq5hus1c _btyzidpf _1h6dlvwl _189et94y _1dqonqa1 _1bsb1osq _11q7cd5j _ect4b1j9"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("tr", {
                                children: headerCells
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("tbody", {
                            children: rowCells
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("j0ZBv", function(module, exports) {
$parcel$export(module.exports, "ProjectAvatar", function () { return $0f20056c3ef369a1$export$ace0beef51336992; });

var $7VQPk = parcelRequire("7VQPk");
const $0f20056c3ef369a1$export$ace0beef51336992 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: 34,
        height: 34,
        viewBox: "0 0 34 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                clipPath: "url(#clip0_4862_19690)",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
                    clipPath: "url(#clip1_4862_19690)",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M33.5999 0H-6.10352e-05V33.6H33.5999V0Z",
                            fill: "#BF63F3"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M4.70404 6.30859V27.3926H28.8876V6.30859H4.70404Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M12.852 28.0643C12.8604 27.8711 12.096 27.3251 11.9196 27.4259C11.6592 27.5603 11.4492 27.7451 11.2644 28.0391C11.0964 28.4003 11.2308 28.5767 11.088 28.8035C10.878 29.1899 10.332 29.7695 10.206 29.9123C10.1892 29.9375 10.1724 29.9543 10.1724 29.9879C10.1304 30.1811 9.95404 31.0211 9.70204 31.6931C9.55924 32.1887 9.49204 32.4911 9.45844 32.6507C9.38284 33.0287 9.41644 33.3395 9.54244 33.6419C9.60964 33.8099 10.416 33.9443 10.542 33.8183C10.7604 33.5915 10.9116 33.3479 10.9956 33.0035C11.0292 32.8691 11.3064 32.6423 11.4576 32.2727C11.4828 32.2139 11.4828 32.1467 11.466 32.0711C11.3232 31.4411 11.676 30.7859 11.676 30.7859C11.676 30.7859 11.7852 30.5339 11.9112 30.2315C12.0456 29.9291 12.222 29.5847 12.3312 29.3831C12.4908 29.0807 12.5748 28.9379 12.6252 28.8455C12.7764 28.5767 12.8436 28.3415 12.8604 28.0643H12.852Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M22.9993 33.7679C23.1253 33.9107 24.0493 33.7595 24.1165 33.5663C24.2089 33.2975 24.2341 33.0203 24.1669 32.6927C24.0325 32.3231 23.8225 32.2811 23.7805 32.0291C23.6713 31.6091 23.6881 30.8279 23.6797 30.6263C23.6797 30.6011 23.6797 30.5675 23.6629 30.5507C23.5621 30.3743 23.1337 29.6519 22.8649 28.9715C22.6297 28.5179 22.4701 28.2407 22.3861 28.0979C22.1845 27.7619 21.9409 27.5687 21.6301 27.4343C21.4621 27.3587 20.7985 27.8375 20.7985 28.0055C20.7985 28.3247 20.8657 28.5851 21.0337 28.8959C21.1009 29.0135 21.0505 29.3663 21.1933 29.7359C21.2185 29.7947 21.2605 29.8451 21.3193 29.8871C21.8401 30.2483 22.0249 30.9707 22.0249 30.9707C22.0249 30.9707 22.1173 31.2227 22.2265 31.5335C22.3273 31.8443 22.4365 32.2139 22.4953 32.4407C22.5793 32.7767 22.6213 32.9363 22.6465 33.0371C22.7221 33.3395 22.8397 33.5579 23.0161 33.7679H22.9993Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M6.38403 7.98828V15.5399L7.63563 13.7759C9.12243 11.6759 12.2472 11.6759 13.734 13.7759L16.0944 17.1107C17.4132 18.9671 20.0676 19.2275 21.714 17.6651C23.0328 16.4135 25.0236 16.3211 26.4516 17.3543V7.99668H6.38403V7.98828Z",
                            fill: "#1868DB"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M20.6724 13.9019C20.6976 13.7591 20.7144 13.5995 20.7144 13.4399C20.7144 13.2803 20.6976 13.1123 20.6724 12.9695C20.5128 12.0875 19.908 11.5499 19.0512 11.4071C18.9084 11.3819 18.7488 11.3735 18.5892 11.3735C18.4296 11.3735 18.2616 11.3903 18.1104 11.4155C17.2536 11.5583 16.6488 12.0959 16.4892 12.9695C16.464 13.1207 16.4472 13.2719 16.4472 13.4399C16.4472 13.6079 16.464 13.7591 16.4892 13.9019C16.6488 14.7755 17.2536 15.3131 18.1104 15.4559C18.2616 15.4811 18.4212 15.4979 18.5892 15.4979C18.7572 15.4979 18.9 15.4895 19.0512 15.4643C19.908 15.3215 20.5212 14.7839 20.6724 13.9019Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M26.4601 25.7122V17.3458C25.0237 16.3126 23.0329 16.4134 21.7225 17.6566C20.0761 19.219 17.4133 18.9586 16.1029 17.1022L13.7425 13.7674C12.2557 11.6674 9.13086 11.6674 7.64406 13.7674L6.39246 15.5314V25.7038H26.4685L26.4601 25.7122Z",
                            fill: "#D8A0F7"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M17.2957 3.24225C17.1949 3.16665 16.2625 3.16665 16.1617 3.24225C16.0189 3.35145 15.9517 3.47745 15.9433 3.62865C15.9853 3.80505 16.1785 3.84705 16.1617 3.96465C16.1617 4.16625 15.9013 4.49385 15.8341 4.57785C15.8257 4.58625 15.8257 4.60305 15.8341 4.61145C15.8677 4.69545 16.0105 5.07345 15.9433 5.39265C15.9433 5.61945 15.9433 5.76225 15.9433 5.83785C15.9433 6.01425 16.0441 6.14025 16.2205 6.26625C16.3213 6.33345 17.1361 6.33345 17.2285 6.26625C17.4049 6.14025 17.5057 6.00585 17.5057 5.83785C17.5057 5.77065 17.7325 5.62785 17.7661 5.43465C17.7661 5.40105 17.7577 5.36745 17.7241 5.34225C17.4217 5.06505 17.5057 4.70385 17.5057 4.70385C17.5057 4.70385 17.5057 4.16625 17.5057 3.93945C17.5057 3.77145 17.5057 3.68745 17.5057 3.63705C17.5057 3.48585 17.4217 3.36825 17.2873 3.25065L17.2957 3.24225Z",
                            fill: "#101214"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M5.56922 26.9049C4.41842 27.0057 4.41842 27.9381 5.56922 28.0389C7.19882 28.1817 8.92082 28.2489 11.1216 28.2573C13.6248 28.2153 14.2464 28.0221 15.9348 28.0389C18.7992 28.0389 23.6208 28.2993 24.7884 28.3665C24.9564 28.3749 25.1328 28.3749 25.3092 28.3665C25.5024 28.3665 25.8048 28.3581 26.3508 28.3413C27.0984 28.3413 28.182 28.3245 29.8032 28.3077C29.7948 27.6525 29.7696 26.1741 29.7444 24.3429C29.7276 22.9401 29.7276 21.2601 29.7444 19.6725C29.7444 16.3881 29.7444 14.3469 29.7444 13.2885C29.7444 10.7769 29.6436 8.90371 29.4672 7.06411C29.3664 6.05611 28.5516 6.05611 28.4592 7.06411C28.2828 8.90371 28.182 10.7853 28.182 13.2885C28.182 14.2629 27.9552 16.2957 27.9216 19.1685C27.9216 19.6389 27.93 20.1009 27.9636 20.5629C28.056 21.7305 28.1064 22.9905 28.14 24.1833C28.1568 25.1157 28.1736 25.9893 28.1904 26.6781C27.1656 26.6781 26.5272 26.6697 26.5272 26.6697C26.5272 26.6697 18.774 26.6697 15.5064 26.6697C13.0452 26.6697 11.8608 26.6697 11.13 26.6697C8.92082 26.6697 7.20722 26.7537 5.57762 26.8881L5.56922 26.9049Z",
                            fill: "#101214"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip0_4862_19690",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "33.6",
                            height: "33.6",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("clipPath", {
                        id: "clip1_4862_19690",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                            width: "33.6",
                            height: "33.6",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("hSlTI", function(module, exports) {
$parcel$export(module.exports, "TableRow", function () { return $1e73233be8a92de3$export$b05581f4e764e162; });
/* table-row.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $41d6y = parcelRequire("41d6y");

var $4SA4u = parcelRequire("4SA4u");

var $leqii = parcelRequire("leqii");

var $24zqb = parcelRequire("24zqb");

var $9p3p1 = parcelRequire("9p3p1");

var $h2BxV = parcelRequire("h2BxV");

var $dJqoM = parcelRequire("dJqoM");

var $20Gca = parcelRequire("20Gca");

var $kbpa7 = parcelRequire("kbpa7");
var $1e73233be8a92de3$var$StatusDisplay = /*#__PURE__*/ function(StatusDisplay) {
    StatusDisplay["ToDo"] = "TO DO";
    StatusDisplay["InProgress"] = "IN PROGRESS";
    StatusDisplay["Complete"] = "COMPLETE";
    return StatusDisplay;
}($1e73233be8a92de3$var$StatusDisplay || {});
var $1e73233be8a92de3$var$PriorityDisplay = /*#__PURE__*/ function(PriorityDisplay) {
    PriorityDisplay["Low"] = "Low";
    PriorityDisplay["Medium"] = "Medium";
    PriorityDisplay["High"] = "High";
    return PriorityDisplay;
}($1e73233be8a92de3$var$PriorityDisplay || {});
const $1e73233be8a92de3$var$inlineRowCss = null;
const $1e73233be8a92de3$var$placeHolderBarStyles = {
    root: null,
    narrow: null,
    wide: null
};
const $1e73233be8a92de3$var$lozengeStyles = {
    toDo: {
        backgroundColor: (0, $kbpa7.wacToken)("color.neutral.light300"),
        color: (0, $kbpa7.wacToken)("color.neutral.light1000")
    },
    inProgress: {
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.blue300"),
        color: (0, $kbpa7.wacToken)("color.neutral.light1000")
    },
    complete: {
        backgroundColor: (0, $kbpa7.wacToken)("color.extended.lime300"),
        color: (0, $kbpa7.wacToken)("color.neutral.light1000")
    }
};
const $1e73233be8a92de3$var$dateCss = null;
const $1e73233be8a92de3$var$avatarCss = null;
const $1e73233be8a92de3$var$epicSummaryCss = null;
const $1e73233be8a92de3$var$tableBorderNotLastRowCss = null;
function $1e73233be8a92de3$var$renderStatusLozenge(status) {
    switch(status){
        case "to do":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.toDo,
                children: "TO DO"
            });
        case "in progress":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.inProgress,
                children: "IN PROGRESS"
            });
        case "complete":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                style: $1e73233be8a92de3$var$lozengeStyles.complete,
                children: "COMPLETE"
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                    "_1bsb1lev"
                ])
            });
    }
}
function $1e73233be8a92de3$var$renderDateLozenge(dueDate) {
    if (!dueDate) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb1lev"
        ])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_ect4b1j9 _k48pni7l _1wyb94pf _vwz41j6v _syazpmk4"
        ]),
        style: {
            "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000"))
        },
        children: (0, $41d6y.format)(dueDate, "MMM do, yyyy")
    });
}
function $1e73233be8a92de3$var$renderPriority(priority) {
    switch(priority){
        case "low":
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9p3p1))), {
                        label: "low priority",
                        color: "var(--ds-icon-accent-blue, #1D7AFC)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "Low"
                    })
                ]
            });
        case "medium":
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h2BxV))), {
                        label: "medium priority",
                        color: "var(--ds-icon-accent-yellow, #B38600)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "Medium"
                    })
                ]
            });
        case "high":
            return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o _zulp1kwk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24zqb))), {
                        label: "high priority",
                        color: "var(--ds-icon-accent-red, #C9372C)"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: "High"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
                    "_1bsb1lev"
                ])
            });
    }
}
function $1e73233be8a92de3$var$renderAssignee(assignee, assigneeImgSrc) {
    if (assignee && assigneeImgSrc) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o",
            "_1e0c116y _4cvr1h6o _zulp1kwk"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
                appearance: "circle",
                src: assigneeImgSrc,
                size: "small",
                name: assignee
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                children: assignee
            })
        ]
    });
    else if (assignee) return assignee;
    else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb1lev"
        ])
    });
}
const $1e73233be8a92de3$export$b05581f4e764e162 = ({ type: type, summary: summary, status: status, dueDate: dueDate, priority: priority, assignee: assignee, assigneeImgSrc: assigneeImgSrc, isLastRow: isLastRow })=>{
    const summaryIcon = type === "epic" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($leqii))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-purple, #8270DB)"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dJqoM))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-blue, #1D7AFC)"
    });
    const summaryCell = summary || /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _4t3i1kwk _1itk1oki _tzy4sxj9 _1e0c1o8l _1reo15vq _18m915vq _aetrb3bt _18postnw _15l2idpf _19doqkx9 _1qdg1osq _z0ai1ssb _16r2zzgt _46tsv569",
            "_1bsb3jzc"
        ])
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    type === "epic" && "_k48p1fw0",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    className: (0, $2jatx.default)([
                        "_1e0c116y _4cvr1h6o _zulp1kwk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: summaryIcon
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: summaryCell
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderStatusLozenge(status)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderDateLozenge(dueDate)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    "_pxtolvwl _1vn8nqa1 _1ej8t94y",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderPriority(priority)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("td", {
                className: (0, $2jatx.default)([
                    "_s7n4nkob _4t3i8pqr _bozgr2lw _y4tir2lw _1wyb11yk _vwz41j6v _o5721q9c",
                    !isLastRow && "_1ezzlvwl _12ornqa1 _1r62t94y"
                ]),
                children: $1e73233be8a92de3$var$renderAssignee(assignee, assigneeImgSrc)
            })
        ]
    });
};

});
parcelRegister("41d6y", function(module, exports) {
$parcel$export(module.exports, "format", function () { return $2ed16bc14c3278e0$export$d9468344d3651243; });

var $04szs = parcelRequire("04szs");

var $52y57 = parcelRequire("52y57");

var $eULoq = parcelRequire("eULoq");

var $kaf1h = parcelRequire("kaf1h");

var $eKVtb = parcelRequire("eKVtb");

var $1vsWe = parcelRequire("1vsWe");

var $frdJf = parcelRequire("frdJf");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $2ed16bc14c3278e0$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $2ed16bc14c3278e0$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $2ed16bc14c3278e0$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $2ed16bc14c3278e0$var$doubleQuoteRegExp = /''/g;
const $2ed16bc14c3278e0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $2ed16bc14c3278e0$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    var _options_locale2, _ref;
    const locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $04szs.enUS);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    const firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    const weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    const originalDate = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    if (!(0, $1vsWe.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($2ed16bc14c3278e0$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $kaf1h.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($2ed16bc14c3278e0$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $2ed16bc14c3278e0$var$cleanEscapedString(substring)
        };
        if ((0, $eULoq.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($2ed16bc14c3278e0$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $eKVtb.isProtectedWeekYearToken)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $eKVtb.isProtectedDayOfYearToken)(token)) (0, $eKVtb.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $eULoq.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $2ed16bc14c3278e0$var$cleanEscapedString(input) {
    const matched = input.match($2ed16bc14c3278e0$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($2ed16bc14c3278e0$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$2ed16bc14c3278e0$export$2e2bcd8739ae039 = $2ed16bc14c3278e0$export$d9468344d3651243;

});
parcelRegister("eULoq", function(module, exports) {
$parcel$export(module.exports, "formatters", function () { return $adbb0eed5a15b217$export$fe98a034cfb96d55; });

var $3vh0T = parcelRequire("3vh0T");

var $kL8sr = parcelRequire("kL8sr");

var $eOBb6 = parcelRequire("eOBb6");

var $3eRpB = parcelRequire("3eRpB");

var $kH0Cl = parcelRequire("kH0Cl");

var $3gdE9 = parcelRequire("3gdE9");

var $9evqZ = parcelRequire("9evqZ");
const $adbb0eed5a15b217$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $adbb0eed5a15b217$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $9evqZ.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $kH0Cl.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $3gdE9.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $3gdE9.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $eOBb6.getISOWeekYear)(date);
        // Padding
        return (0, $3gdE9.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $3gdE9.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $3gdE9.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $3gdE9.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $9evqZ.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $3gdE9.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3eRpB.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $3gdE9.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $kL8sr.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $3gdE9.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $9evqZ.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $3vh0T.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $3gdE9.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $3gdE9.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $3gdE9.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $3gdE9.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $adbb0eed5a15b217$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $9evqZ.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $9evqZ.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3gdE9.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3gdE9.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $9evqZ.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $9evqZ.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $9evqZ.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $adbb0eed5a15b217$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $adbb0eed5a15b217$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $adbb0eed5a15b217$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $3gdE9.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $3gdE9.addLeadingZeros)(+date, token.length);
    }
};
function $adbb0eed5a15b217$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $3gdE9.addLeadingZeros)(minutes, 2);
}
function $adbb0eed5a15b217$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $3gdE9.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $adbb0eed5a15b217$var$formatTimezone(offset, delimiter);
}
function $adbb0eed5a15b217$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $3gdE9.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $3gdE9.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("3vh0T", function(module, exports) {
$parcel$export(module.exports, "getDayOfYear", function () { return $28d176d71133a583$export$d3b42cd8452deec; });

var $bMbri = parcelRequire("bMbri");

var $fVuI3 = parcelRequire("fVuI3");

var $frdJf = parcelRequire("frdJf");
function $28d176d71133a583$export$d3b42cd8452deec(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $bMbri.differenceInCalendarDays)(_date, (0, $fVuI3.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$28d176d71133a583$export$2e2bcd8739ae039 = $28d176d71133a583$export$d3b42cd8452deec;

});
parcelRegister("bMbri", function(module, exports) {
$parcel$export(module.exports, "differenceInCalendarDays", function () { return $892d0cfd68028b95$export$4a02e9c37dab4871; });

var $kxmHU = parcelRequire("kxmHU");

var $32VtV = parcelRequire("32VtV");

var $59xhD = parcelRequire("59xhD");

var $eV9M6 = parcelRequire("eV9M6");
function $892d0cfd68028b95$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $32VtV.normalizeDates)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $eV9M6.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, $eV9M6.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $kxmHU.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $kxmHU.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $59xhD.millisecondsInDay));
}
var // Fallback for modularized imports:
$892d0cfd68028b95$export$2e2bcd8739ae039 = $892d0cfd68028b95$export$4a02e9c37dab4871;

});

parcelRegister("fVuI3", function(module, exports) {
$parcel$export(module.exports, "startOfYear", function () { return $b984002940bddac0$export$f91e89d3d0406102; });

var $frdJf = parcelRequire("frdJf");
function $b984002940bddac0$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$b984002940bddac0$export$2e2bcd8739ae039 = $b984002940bddac0$export$f91e89d3d0406102;

});


parcelRegister("kL8sr", function(module, exports) {
$parcel$export(module.exports, "getISOWeek", function () { return $f1cec1f1d654300a$export$7cabdc5698b63e2f; });

var $59xhD = parcelRequire("59xhD");

var $beVQG = parcelRequire("beVQG");

var $lsW7j = parcelRequire("lsW7j");

var $frdJf = parcelRequire("frdJf");
function $f1cec1f1d654300a$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $beVQG.startOfISOWeek)(_date) - +(0, $lsW7j.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $59xhD.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$f1cec1f1d654300a$export$2e2bcd8739ae039 = $f1cec1f1d654300a$export$7cabdc5698b63e2f;

});
parcelRegister("beVQG", function(module, exports) {
$parcel$export(module.exports, "startOfISOWeek", function () { return $82ede015fb00b7b5$export$6173213f95a4431e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $6cztB = parcelRequire("6cztB");
function $82ede015fb00b7b5$export$6173213f95a4431e(date, options) {
    return (0, $6cztB.startOfWeek)(date, (0, $dPABA._)((0, $6ogO3._)({}, options), {
        weekStartsOn: 1
    }));
}
var // Fallback for modularized imports:
$82ede015fb00b7b5$export$2e2bcd8739ae039 = $82ede015fb00b7b5$export$6173213f95a4431e;

});

parcelRegister("lsW7j", function(module, exports) {
$parcel$export(module.exports, "startOfISOWeekYear", function () { return $fa094b543f5dd36c$export$236bdfa374eb69a9; });

var $hs1PO = parcelRequire("hs1PO");

var $eOBb6 = parcelRequire("eOBb6");

var $beVQG = parcelRequire("beVQG");
function $fa094b543f5dd36c$export$236bdfa374eb69a9(date, options) {
    const year = (0, $eOBb6.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $beVQG.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$fa094b543f5dd36c$export$2e2bcd8739ae039 = $fa094b543f5dd36c$export$236bdfa374eb69a9;

});
parcelRegister("eOBb6", function(module, exports) {
$parcel$export(module.exports, "getISOWeekYear", function () { return $ac9292f96045be59$export$3dbc52535f6f8fcc; });

var $hs1PO = parcelRequire("hs1PO");

var $beVQG = parcelRequire("beVQG");

var $frdJf = parcelRequire("frdJf");
function $ac9292f96045be59$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $hs1PO.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $beVQG.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $hs1PO.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $beVQG.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$ac9292f96045be59$export$2e2bcd8739ae039 = $ac9292f96045be59$export$3dbc52535f6f8fcc;

});



parcelRegister("3eRpB", function(module, exports) {
$parcel$export(module.exports, "getWeek", function () { return $25bc1c6d66f955c1$export$efe19b760242b2fc; });

var $59xhD = parcelRequire("59xhD");

var $6cztB = parcelRequire("6cztB");

var $lLEjQ = parcelRequire("lLEjQ");

var $frdJf = parcelRequire("frdJf");
function $25bc1c6d66f955c1$export$efe19b760242b2fc(date, options) {
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $6cztB.startOfWeek)(_date, options) - +(0, $lLEjQ.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $59xhD.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$25bc1c6d66f955c1$export$2e2bcd8739ae039 = $25bc1c6d66f955c1$export$efe19b760242b2fc;

});
parcelRegister("lLEjQ", function(module, exports) {
$parcel$export(module.exports, "startOfWeekYear", function () { return $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f; });

var $52y57 = parcelRequire("52y57");

var $hs1PO = parcelRequire("hs1PO");

var $kH0Cl = parcelRequire("kH0Cl");

var $6cztB = parcelRequire("6cztB");
function $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const year = (0, $kH0Cl.getWeekYear)(date, options);
    const firstWeek = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $6cztB.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$fd8d434ee1e9a6ff$export$2e2bcd8739ae039 = $fd8d434ee1e9a6ff$export$bb7b45bb8e74da0f;

});
parcelRegister("kH0Cl", function(module, exports) {
$parcel$export(module.exports, "getWeekYear", function () { return $f1084d691f57e4eb$export$12d572480ceb6e58; });

var $52y57 = parcelRequire("52y57");

var $hs1PO = parcelRequire("hs1PO");

var $6cztB = parcelRequire("6cztB");

var $frdJf = parcelRequire("frdJf");
function $f1084d691f57e4eb$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const _date = (0, $frdJf.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $52y57.getDefaultOptions)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const firstWeekOfNextYear = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $6cztB.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $hs1PO.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $6cztB.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$f1084d691f57e4eb$export$2e2bcd8739ae039 = $f1084d691f57e4eb$export$12d572480ceb6e58;

});



parcelRegister("3gdE9", function(module, exports) {
$parcel$export(module.exports, "addLeadingZeros", function () { return $25fd73a5842a07c9$export$c8306e720e213c0f; });
function $25fd73a5842a07c9$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("9evqZ", function(module, exports) {
$parcel$export(module.exports, "lightFormatters", function () { return $6b8dce11d3227385$export$b0d4b338e1516f13; });

var $3gdE9 = parcelRequire("3gdE9");
const $6b8dce11d3227385$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $3gdE9.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $3gdE9.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $3gdE9.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $3gdE9.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("kaf1h", function(module, exports) {
$parcel$export(module.exports, "longFormatters", function () { return $eae06464081ea5f2$export$70cc8fd02856fd58; });
const $eae06464081ea5f2$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $eae06464081ea5f2$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $eae06464081ea5f2$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $eae06464081ea5f2$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $eae06464081ea5f2$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $eae06464081ea5f2$var$timeLongFormatter(timePattern, formatLong));
};
const $eae06464081ea5f2$export$70cc8fd02856fd58 = {
    p: $eae06464081ea5f2$var$timeLongFormatter,
    P: $eae06464081ea5f2$var$dateTimeLongFormatter
};

});

parcelRegister("eKVtb", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $abe1f0d5862b9833$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $abe1f0d5862b9833$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $abe1f0d5862b9833$export$f5f38f90ecaaf879; });
const $abe1f0d5862b9833$var$dayOfYearTokenRE = /^D+$/;
const $abe1f0d5862b9833$var$weekYearTokenRE = /^Y+$/;
const $abe1f0d5862b9833$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $abe1f0d5862b9833$export$c6cc36aa33304772(token) {
    return $abe1f0d5862b9833$var$dayOfYearTokenRE.test(token);
}
function $abe1f0d5862b9833$export$c6b49d6dceb604a1(token) {
    return $abe1f0d5862b9833$var$weekYearTokenRE.test(token);
}
function $abe1f0d5862b9833$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $abe1f0d5862b9833$var$message(token, format, input);
    console.warn(_message);
    if ($abe1f0d5862b9833$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $abe1f0d5862b9833$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("1vsWe", function(module, exports) {
$parcel$export(module.exports, "isValid", function () { return $118f223a25ac1e92$export$1ea939691cdc45b8; });

var $838H2 = parcelRequire("838H2");

var $frdJf = parcelRequire("frdJf");
function $118f223a25ac1e92$export$1ea939691cdc45b8(date) {
    return !(!(0, $838H2.isDate)(date) && typeof date !== "number" || isNaN(+(0, $frdJf.toDate)(date)));
}
var // Fallback for modularized imports:
$118f223a25ac1e92$export$2e2bcd8739ae039 = $118f223a25ac1e92$export$1ea939691cdc45b8;

});
parcelRegister("838H2", function(module, exports) {
$parcel$export(module.exports, "isDate", function () { return $5dc558d396f78e9b$export$871608497c498473; });
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $5dc558d396f78e9b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$5dc558d396f78e9b$export$2e2bcd8739ae039 = $5dc558d396f78e9b$export$871608497c498473;

});



parcelRegister("24zqb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd64b41739e4b5a1ac8c09f1bbfed3e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18276e72087165bb$var$_react = $18276e72087165bb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $18276e72087165bb$var$_baseNew = $18276e72087165bb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $18276e72087165bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityHigh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for high work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18276e72087165bb$var$PriorityHighIcon = (props)=>/*#__PURE__*/ $18276e72087165bb$var$_react.default.createElement($18276e72087165bb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 9.25-5.5-3.625a.75.75 0 0 0-.826 0l-5.5 3.625.826 1.252L8 7.149l5.087 3.353z"/>`
    }, props));
$18276e72087165bb$var$PriorityHighIcon.displayName = 'PriorityHighIcon';
var $18276e72087165bb$var$_default = module.exports.default = $18276e72087165bb$var$PriorityHighIcon;

});

parcelRegister("9p3p1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0a790d91d8a02a088319fd35139d8a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d891685efcb0c3b$var$_react = $6d891685efcb0c3b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6d891685efcb0c3b$var$_baseNew = $6d891685efcb0c3b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6d891685efcb0c3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityLow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for low work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d891685efcb0c3b$var$PriorityLowIcon = (props)=>/*#__PURE__*/ $6d891685efcb0c3b$var$_react.default.createElement($6d891685efcb0c3b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.913 7.251-5.5 3.625a.75.75 0 0 1-.826 0l-5.5-3.625.826-1.252L8 9.352l5.087-3.353z"/>`
    }, props));
$6d891685efcb0c3b$var$PriorityLowIcon.displayName = 'PriorityLowIcon';
var $6d891685efcb0c3b$var$_default = module.exports.default = $6d891685efcb0c3b$var$PriorityLowIcon;

});

parcelRegister("h2BxV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8d7d06aafd80a5763505502d0e6cf1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c67fbf7899919f80$var$_react = $c67fbf7899919f80$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c67fbf7899919f80$var$_baseNew = $c67fbf7899919f80$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c67fbf7899919f80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for medium work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c67fbf7899919f80$var$PriorityMediumIcon = (props)=>/*#__PURE__*/ $c67fbf7899919f80$var$_react.default.createElement($c67fbf7899919f80$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 9.5V11H2V9.5zM14 5v1.5H2V5z"/>`
    }, props));
$c67fbf7899919f80$var$PriorityMediumIcon.displayName = 'PriorityMediumIcon';
var $c67fbf7899919f80$var$_default = module.exports.default = $c67fbf7899919f80$var$PriorityMediumIcon;

});




//# sourceMappingURL=confirmation-page.5d6e328d.js.map
